<template>
  <svg fill="none" viewBox="0 0 428 105" xmlns="http://www.w3.org/2000/svg">
    <rect fill="url(#a)" height="94" rx="16" ry="16" width="428" y="10.34" />
    <path
      d="M73.86 61.23C44.93 47.27 12.56 45.63 0 46.55v52.63h428V71.54c-3.71-1.88-25.56-8.17-62.06 0-36.5 8.18-56.46-13.57-100.25-13.57H165.27c-18.42-1.1-62.5 17.22-91.41 3.26Z"
      fill="url(#b)"
    />
    <path
      d="M354.14 61.23c28.93-13.96 61.3-15.6 73.86-14.68v52.63H0V79.26l.1-.05c3.9-1.99 20.61-10.5 56.79-2.4 36.5 8.18 61.63-18.84 105.42-18.84h100.42c18.42-1.1 62.5 17.22 91.41 3.26Z"
      fill="url(#c)"
    />
    <path
      d="M366.28 101.6c-4.18-2.41-4.2-6.35-.04-8.75 4.16-2.4 10.96-2.4 15.12 0 4.16 2.4 4.18 6.34.04 8.75s-10.94 2.41-15.12 0Z"
      fill="#273B95"
      fill-opacity=".3"
      opacity=".4"
    />
    <path
      d="M378.37 92.83a9.72 9.72 0 0 0-8.76 0c-2.41 1.4-2.41 3.67 0 5.06a9.72 9.72 0 0 0 8.76 0c2.4-1.4 2.4-3.67 0-5.06Z"
      fill="#A3C6CE"
    />
    <path
      d="M373.99 98.05c5.59 0 10.12-3.4 10.12-7.59 0-4.19-4.53-7.59-10.12-7.59-5.6 0-10.13 3.4-10.13 7.59 0 4.2 4.53 7.59 10.13 7.59Z"
      fill="#CAE2E8"
    />
    <path
      d="M373.99 98.05c.66 0 1.3-.05 1.92-.14a8.11 8.11 0 0 0 5.23-7.45c0-3.34-2.15-6.2-5.22-7.45a13.6 13.6 0 0 0-1.93-.14c-5.6 0-10.13 3.4-10.13 7.59 0 4.2 4.53 7.59 10.13 7.59Z"
      fill="#F2F8F9"
    />
    <path
      d="M378.37 83.37a9.72 9.72 0 0 0-8.76 0c-2.41 1.4-2.41 3.67 0 5.06a9.72 9.72 0 0 0 8.76 0c2.4-1.39 2.4-3.67 0-5.06Z"
      fill="#CAE2E8"
    />
    <path
      d="m381.7 86.2-2.42-.96-8.88 3.58 11.92 4.26-.63-6.89Z"
      fill="#CAE2E8"
    />
    <path
      d="M378.37 82.71a9.72 9.72 0 0 0-8.76 0c-2.41 1.4-2.41 3.67 0 5.06a9.72 9.72 0 0 0 8.76 0c2.4-1.39 2.4-3.66 0-5.06Z"
      fill="#BC1958"
    />
    <path
      d="M378.07 82.64a9.05 9.05 0 0 0-8.16 0c-2.25 1.3-2.25 3.42 0 4.71a9.05 9.05 0 0 0 8.16 0c2.24-1.3 2.24-3.41 0-4.7Z"
      fill="#A81D4B"
    />
    <path
      d="M368.45 90.95c-.38-.21-.7-.03-.7.4 0 .44.32.98.7 1.2.38.22.69.04.69-.4s-.31-.98-.7-1.2Z"
      fill="#CAE2E8"
    />
    <path
      d="M368.36 90.7c-.38-.22-.69-.04-.69.4s.31.97.69 1.2c.38.21.69.03.69-.4 0-.44-.31-.98-.7-1.2Z"
      fill="#FF8C1A"
    />
    <path
      d="M368.2 90.93c-.27-.16-.49-.03-.49.28 0 .31.22.7.5.85.26.16.48.03.48-.28 0-.31-.22-.7-.49-.85Z"
      fill="#E56813"
    />
    <path
      d="M368.2 92.06c.27.16.5.03.5-.28 0-.31-.23-.7-.5-.85"
      fill="#E56813"
      opacity=".2"
    />
    <path
      d="M368.45 93.42c-.38-.21-.7-.03-.7.4 0 .44.32.98.7 1.2.38.21.69.04.69-.4s-.31-.98-.7-1.2Z"
      fill="#CAE2E8"
    />
    <path
      d="M368.36 93.17c-.38-.22-.69-.04-.69.4s.31.97.69 1.2c.38.21.69.03.69-.4 0-.44-.31-.98-.7-1.2Z"
      fill="#FF8C1A"
    />
    <path
      d="M368.2 93.4c-.27-.16-.49-.03-.49.28 0 .31.22.7.5.85.26.16.48.03.48-.28 0-.31-.22-.7-.49-.85Z"
      fill="#E56813"
    />
    <path
      d="M368.2 94.53c.27.16.5.03.5-.28 0-.31-.23-.7-.5-.85"
      fill="#E56813"
      opacity=".2"
    />
    <path
      d="M373.99 87.14c4.03 0 7.3-2.45 7.3-5.47 0-3.02-3.27-5.47-7.3-5.47-4.04 0-7.3 2.45-7.3 5.47 0 3.02 3.26 5.47 7.3 5.47Z"
      fill="#CAE2E8"
    />
    <path
      d="M373.99 87.14c.47 0 .94-.03 1.39-.1a5.85 5.85 0 0 0 3.77-5.37c0-2.4-1.56-4.47-3.77-5.37a9.7 9.7 0 0 0-1.4-.1c-4.03 0-7.3 2.45-7.3 5.47 0 3.02 3.27 5.47 7.3 5.47Z"
      fill="#F2F8F9"
    />
    <path
      d="M379.85 84.92c.4-.4.73-.85.97-1.33l-.42-4.53a5.7 5.7 0 0 0-.86-.93l-1.6-.64-8.9 3.58 10.8 3.85Zm-12.27-.62a6.62 6.62 0 0 0 2.64 2.05V84.3h-2.64Zm4.93-.85c-.22-.13-.4-.02-.4.24 0 .25.18.57.4.7.22.13.4.02.4-.24a.9.9 0 0 0-.4-.7Z"
      fill="#CAE2E8"
    />
    <path
      d="M372.46 83.3c-.22-.13-.4-.02-.4.24 0 .25.17.57.4.7.22.13.4.02.4-.24a.9.9 0 0 0-.4-.7Z"
      fill="#36393F"
    />
    <path
      d="M368.17 80.94c-.22-.13-.4-.02-.4.24 0 .25.18.57.4.7.22.13.4.02.4-.24a.9.9 0 0 0-.4-.7Z"
      fill="#CAE2E8"
    />
    <path
      d="M368.12 80.8c-.23-.14-.4-.03-.4.23 0 .25.17.57.4.7.22.13.4.02.4-.24a.9.9 0 0 0-.4-.7Z"
      fill="#36393F"
    />
    <path d="m369.3 82.56-3.46 3.06 4.38-2.53-.92-.53Z" fill="#FF8C1A" />
    <path d="m365.84 85.62 4.38-1.32v-1.21l-4.38 2.53Z" fill="#E56813" />
    <path
      d="M378.96 75.27c-2.73-1.58-7.21-1.58-9.95 0-2.74 1.58-2.74 4.17 0 5.75s7.22 1.58 9.95 0c2.74-1.58 2.74-4.17 0-5.75Z"
      fill="#404449"
    />
    <path
      d="M379.38 75.53a5.94 5.94 0 0 0-.42-.26c-2.73-1.58-7.21-1.58-9.95 0-.15.08-.28.17-.41.26-1.72 1.47-1.47 3.49.77 4.78a10.23 10.23 0 0 0 9.23 0c2.24-1.3 2.5-3.31.78-4.78Z"
      fill="#36393F"
    />
    <path
      d="M369.38 80.31a10.23 10.23 0 0 0 9.22 0c2.24-1.3 2.5-3.31.78-4.78a5.94 5.94 0 0 0-.42-.26"
      fill="#1E2123"
    />
    <path
      d="M378.56 76.64v-6.71h-9.14v6.71c-.04.7.4 1.42 1.33 1.96a7.19 7.19 0 0 0 6.48 0c.92-.54 1.36-1.25 1.33-1.96Z"
      fill="#1E2123"
    />
    <path
      d="M378.56 76.64v-6.71h-9.14v6.71c-.04.7.4 1.42 1.33 1.96a7.19 7.19 0 0 0 6.48 0c.92-.54 1.36-1.25 1.33-1.96Z"
      fill="#1E2123"
    />
    <path
      d="M371.81 79.04a7.3 7.3 0 0 0 5.42-.44c.92-.54 1.36-1.25 1.33-1.96v-6.71h-6.75v9.11Z"
      fill="#0C0E0F"
    />
    <path
      d="M377.23 68.2a7.19 7.19 0 0 0-6.48 0c-1.79 1.03-1.79 2.71 0 3.74a7.19 7.19 0 0 0 6.48 0c1.78-1.03 1.78-2.71 0-3.74Z"
      fill="#404449"
    />
    <path
      d="M370.75 71.94a7.19 7.19 0 0 0 6.48 0c1.78-1.03 1.78-2.71 0-3.74"
      fill="#36393F"
    />
    <path
      d="M70.25 58.3c0 .56-.6 2-1.34 2-.74 0-1.34-1.44-1.34-2 0-.55.6-1 1.34-1 .74 0 1.34.45 1.34 1Z"
      fill="#079142"
    />
    <path
      d="M68.71 57.46c-.33 0-.64.1-.88.25a.85.85 0 0 0-.26.6c0 .55.6 1.98 1.34 1.98a.7.7 0 0 0 .38-.12 3 3 0 0 0 .77-1.7c0-.56-.6-1-1.35-1Z"
      fill="#14C45F"
    />
    <path
      d="M69.77 57.85a1.7 1.7 0 0 0-1.53.11.85.85 0 0 0-.27.6 3 3 0 0 0 .77 1.7.5.5 0 0 0 .17.03.7.7 0 0 0 .38-.12 3 3 0 0 0 .77-1.7.82.82 0 0 0-.3-.62Z"
      fill="#0BA852"
    />
    <path
      d="M68.91 58.93a.46.46 0 1 0 0-.92.46.46 0 0 0 0 .92Z"
      fill="#14C45F"
    />
    <path
      d="M68.85 58.02a.46.46 0 0 0 0 .9.46.46 0 0 0 0-.9Zm.32-.7a1.66 1.66 0 0 0-.26-.02c-.74 0-1.34.45-1.34 1"
      fill="#27E071"
    />
    <path
      d="M69.5 57.37a1.29 1.29 0 0 0-1.17 0c-.32.18-.32.48 0 .67.32.18.84.18 1.16 0 .32-.19.32-.49 0-.67Z"
      fill="#079142"
    />
    <path
      d="M69.5 57.28a1.29 1.29 0 0 0-1.17 0c-.32.19-.32.49 0 .67.32.19.84.19 1.16 0 .32-.18.32-.48 0-.67Z"
      fill="#DB8C19"
    />
    <path
      d="M69.45 57.27a1.2 1.2 0 0 0-1.08 0c-.3.17-.3.45 0 .63.3.17.79.17 1.08 0 .3-.18.3-.46 0-.63Z"
      fill="#D8741A"
    />
    <path
      d="M68.37 57.9c.3.17.79.17 1.08 0 .3-.18.3-.46 0-.63"
      fill="#C96717"
    />
    <path
      d="M68.66 58c.16.03.34.03.5 0v-.51l-.5.11v.4Z"
      fill="#C96717"
      opacity=".3"
    />
    <path
      d="M68.73 57.7c-.18 0-.35-.12-.35-.41 0-.3.2-.67.47-.82.2-.11.4-.09.5.05.07.07.1.17.1.3 0 .3-.21.66-.48.81a.48.48 0 0 1-.24.07Zm.37-1.06a.26.26 0 0 0-.13.04.8.8 0 0 0-.35.61c0 .05 0 .18.1.18.04 0 .09-.02.13-.04a.8.8 0 0 0 .36-.62.23.23 0 0 0-.04-.14.1.1 0 0 0-.07-.03Z"
      fill="#F7A23C"
    />
    <path
      d="M69.45 56.81a.45.45 0 0 0-.1-.3.3.3 0 0 0-.14-.1.58.58 0 0 0-.11.06 1 1 0 0 0-.46.68.8.8 0 0 1 .33-.47.26.26 0 0 1 .12-.04c.04 0 .06 0 .08.03.02.03.04.08.04.14a.8.8 0 0 1-.36.62.26.26 0 0 1-.12.04c-.06 0-.09-.04-.1-.09.02.17.12.26.23.3a.63.63 0 0 0 .11-.05c.27-.15.48-.51.48-.82Z"
      fill="#E59120"
    />
    <path
      d="M43.25 79.6c-5.95-3.43-5.98-9.04-.05-12.46 5.92-3.42 15.6-3.42 21.53 0 5.92 3.42 5.94 9.03.05 12.46-5.89 3.44-15.58 3.44-21.53 0Z"
      fill="#273B95"
      fill-opacity=".3"
      opacity=".4"
    />
    <path
      d="M55.85 74.32V54.83h-3.38v19.58h.01c.04.22.2.43.48.6.67.38 1.74.38 2.4 0 .29-.17.44-.38.47-.6h.01v-.09Z"
      fill="#663109"
    />
    <path
      d="M53.25 54.83h-.78v19.58h.01c.04.22.2.43.48.6.1.05.2.1.3.13v-20.3Z"
      fill="#874107"
    />
    <path
      d="M52.97 55.52c-.66-.38-.67-1-.01-1.38a2.65 2.65 0 0 1 2.39 0c.66.38.66 1 0 1.38-.65.38-1.72.38-2.38 0Z"
      fill="#D16F26"
    />
    <path
      d="M66.55 65.74c-.7-.4-1.82-.4-2.51 0-.7.4-.7 1.05 0 1.45.69.4 1.82.4 2.5 0 .7-.4.7-1.05 0-1.45Z"
      fill="#D8741A"
    />
    <path
      d="M65.3 67.23c1.6 0 2.9-.97 2.9-2.17s-1.3-2.17-2.9-2.17c-1.6 0-2.9.97-2.9 2.17s1.3 2.17 2.9 2.17Z"
      fill="#87083C"
    />
    <path
      d="M65.3 67.23c.18 0 .36-.01.54-.04a2.32 2.32 0 0 0 1.5-2.13c0-.96-.62-1.78-1.5-2.13a3.88 3.88 0 0 0-.55-.04c-1.6 0-2.9.97-2.9 2.17s1.3 2.17 2.9 2.17Z"
      fill="#A80C48"
    />
    <path
      d="M65.84 62.93a3.88 3.88 0 0 0-.55-.04c-1.6 0-2.9.97-2.9 2.17"
      fill="#C1055A"
    />
    <path
      d="M66.55 63.03c-.7-.4-1.82-.4-2.51 0-.7.4-.7 1.05 0 1.45.69.4 1.82.4 2.5 0 .7-.4.7-1.05 0-1.45Z"
      fill="#87083C"
    />
    <path d="m67.5 63.84-.7-.27-2.54 1.02 3.42 1.22-.18-1.97Z" fill="#87083C" />
    <path
      d="M66.55 62.84c-.7-.4-1.82-.4-2.51 0-.7.4-.7 1.05 0 1.45.69.4 1.82.4 2.5 0 .7-.4.7-1.05 0-1.45Z"
      fill="#DB8C19"
    />
    <path
      d="M67.51 65.8a4.9 4.9 0 0 1-4.44 0 2 2 0 0 1-.67-.56l.03.15c.15.2.36.38.64.54 1.22.7 3.22.7 4.44 0 .28-.16.5-.34.65-.54l.02-.15c-.15.2-.37.4-.67.57Z"
      fill="#DB8C19"
      opacity=".7"
    />
    <path
      d="M68.09 65.63a2.3 2.3 0 0 1-.58.46c-1.22.7-3.22.7-4.44 0a2.08 2.08 0 0 1-.57-.46l.1.24c.13.12.29.24.47.35 1.22.7 3.22.7 4.44 0 .19-.11.34-.23.47-.35.04-.08.08-.16.1-.24Z"
      fill="#DB8C19"
      opacity=".7"
    />
    <path
      d="m67.72 66.24-.2.14a4.93 4.93 0 0 1-4.66-.14c.1.12.23.24.36.34 1.18.6 2.96.6 4.14 0 .14-.1.26-.22.36-.34Z"
      fill="#DB8C19"
      opacity=".7"
    />
    <path
      d="M66.46 62.82a2.6 2.6 0 0 0-2.34 0c-.64.37-.64.98 0 1.35.65.37 1.7.37 2.34 0 .64-.37.64-.98 0-1.35Z"
      fill="#D8741A"
    />
    <path
      d="M64.12 64.17c.65.37 1.7.37 2.34 0 .64-.37.64-.98 0-1.35"
      fill="#C96717"
    />
    <path
      d="M64.75 64.4c.35.07.74.07 1.1 0v-1.12l-1.1.26v.85Z"
      fill="#C96717"
      opacity=".3"
    />
    <path
      d="M64.9 63.76c-.38 0-.76-.28-.76-.9 0-.66.45-1.44 1.02-1.77.42-.24.85-.2 1.09.1a1 1 0 0 1 .2.64c0 .66-.45 1.44-1.03 1.77-.18.1-.36.16-.53.16Zm.79-2.3a.56.56 0 0 0-.27.08c-.41.24-.76.84-.76 1.32 0 .12.02.38.23.38.08 0 .17-.03.27-.08.42-.24.77-.85.77-1.33a.5.5 0 0 0-.08-.3.19.19 0 0 0-.16-.08Z"
      fill="#F7A23C"
    />
    <path
      d="M66.44 61.83a.99.99 0 0 0-.2-.63.68.68 0 0 0-.3-.22 1.2 1.2 0 0 0-.25.11c-.49.28-.89.89-1 1.47.1-.4.4-.83.73-1.02.1-.06.2-.09.27-.09s.12.02.16.07a.5.5 0 0 1 .08.31c0 .48-.35 1.09-.77 1.32-.1.06-.19.1-.27.1-.12 0-.18-.1-.2-.2.04.37.24.58.48.66.08-.02.17-.06.25-.1a2.23 2.23 0 0 0 1.02-1.78Z"
      fill="#E59120"
    />
    <path
      d="M53 67.99c-.69-.4-1.82-.4-2.5 0-.7.4-.7 1.05 0 1.45.68.4 1.81.4 2.5 0 .7-.4.7-1.05 0-1.45Z"
      fill="#D8741A"
    />
    <path
      d="M51.75 69.48c1.6 0 2.9-.97 2.9-2.17s-1.3-2.17-2.9-2.17c-1.6 0-2.9.97-2.9 2.17s1.3 2.17 2.9 2.17Z"
      fill="#87083C"
    />
    <path
      d="M51.75 69.48c.19 0 .37-.01.55-.04a2.32 2.32 0 0 0 1.5-2.13c0-.96-.62-1.78-1.5-2.13a3.9 3.9 0 0 0-.55-.04c-1.6 0-2.9.97-2.9 2.17s1.3 2.17 2.9 2.17Z"
      fill="#A80C48"
    />
    <path
      d="M52.3 65.18a3.88 3.88 0 0 0-.55-.04c-1.6 0-2.9.97-2.9 2.17"
      fill="#C1055A"
    />
    <path
      d="M53 65.28c-.69-.4-1.82-.4-2.5 0-.7.4-.7 1.05 0 1.45.68.4 1.81.4 2.5 0 .7-.4.7-1.05 0-1.45Z"
      fill="#87083C"
    />
    <path
      d="m53.96 66.09-.7-.27-2.54 1.02 3.42 1.22-.18-1.97Z"
      fill="#87083C"
    />
    <path
      d="M53 65.1c-.69-.4-1.82-.4-2.5 0-.7.39-.7 1.04 0 1.44.68.4 1.81.4 2.5 0 .7-.4.7-1.05 0-1.45Z"
      fill="#DB8C19"
    />
    <path
      d="M53.97 68.06c-1.22.7-3.22.7-4.44 0-.3-.17-.52-.37-.67-.57l.02.15c.15.2.37.38.65.54 1.22.7 3.22.7 4.44 0 .28-.16.5-.34.64-.54l.03-.15c-.15.2-.38.4-.67.57Z"
      fill="#DB8C19"
      opacity=".7"
    />
    <path
      d="M54.54 67.88c-.14.17-.33.32-.57.46-1.22.7-3.22.7-4.44 0a2.3 2.3 0 0 1-.58-.46l.1.24c.14.12.3.24.48.35 1.22.7 3.22.7 4.44 0 .18-.11.34-.23.47-.35.04-.08.08-.16.1-.24Z"
      fill="#DB8C19"
      opacity=".7"
    />
    <path
      d="M54.18 68.49a4.92 4.92 0 0 1-4.87 0c.11.12.23.24.37.34a5 5 0 0 0 4.14 0c.13-.1.26-.22.36-.34Z"
      fill="#DB8C19"
      opacity=".7"
    />
    <path
      d="M52.92 65.07a2.6 2.6 0 0 0-2.34 0c-.64.37-.64.98 0 1.35.64.37 1.7.37 2.34 0 .64-.37.64-.98 0-1.35Z"
      fill="#D8741A"
    />
    <path
      d="M50.58 66.42c.64.37 1.7.37 2.34 0 .64-.37.64-.98 0-1.35"
      fill="#C96717"
    />
    <path
      d="M51.2 66.64c.36.08.75.07 1.1 0v-1.1l-1.1.25v.85Z"
      fill="#C96717"
      opacity=".3"
    />
    <path
      d="M51.35 66c-.37 0-.75-.27-.75-.89 0-.66.45-1.44 1.02-1.77.42-.24.85-.2 1.09.1a1 1 0 0 1 .2.64c0 .66-.46 1.44-1.03 1.77-.18.1-.36.16-.53.16Zm.8-2.3a.56.56 0 0 0-.27.09 1.7 1.7 0 0 0-.77 1.32c0 .12.03.38.24.38.08 0 .17-.03.27-.08.42-.24.77-.85.77-1.33a.5.5 0 0 0-.09-.3.19.19 0 0 0-.15-.08Z"
      fill="#F7A23C"
    />
    <path
      d="M52.9 64.08a1 1 0 0 0-.2-.63.69.69 0 0 0-.3-.22 1.2 1.2 0 0 0-.25.11c-.5.28-.89.89-1 1.47.1-.4.4-.83.73-1.02.1-.06.19-.09.27-.09.06 0 .11.02.15.07a.5.5 0 0 1 .09.31c0 .48-.36 1.09-.77 1.33-.1.05-.2.08-.27.08-.12 0-.18-.09-.21-.18.05.36.25.57.49.65.08-.02.16-.06.25-.1a2.23 2.23 0 0 0 1.02-1.78Z"
      fill="#E59120"
    />
    <path
      d="M40.04 60.29c-.69-.4-1.81-.4-2.5 0-.7.4-.7 1.05 0 1.45.69.4 1.81.4 2.5 0 .7-.4.7-1.05 0-1.45Z"
      fill="#D8741A"
    />
    <path
      d="M38.79 61.78c1.6 0 2.9-.97 2.9-2.17s-1.3-2.17-2.9-2.17c-1.6 0-2.9.97-2.9 2.17s1.3 2.17 2.9 2.17Z"
      fill="#87083C"
    />
    <path
      d="M38.79 61.78c.19 0 .37-.01.55-.04a2.32 2.32 0 0 0 1.5-2.13c0-.96-.62-1.78-1.5-2.13a3.89 3.89 0 0 0-.55-.04c-1.6 0-2.9.97-2.9 2.17s1.3 2.17 2.9 2.17Z"
      fill="#A80C48"
    />
    <path
      d="M39.34 57.48a3.89 3.89 0 0 0-.55-.04c-1.6 0-2.9.97-2.9 2.17"
      fill="#C1055A"
    />
    <path
      d="M40.04 57.58c-.69-.4-1.81-.4-2.5 0-.7.4-.7 1.05 0 1.45.69.4 1.81.4 2.5 0 .7-.4.7-1.05 0-1.45Z"
      fill="#87083C"
    />
    <path d="m41 58.39-.7-.27-2.54 1.02 3.42 1.22-.18-1.97Z" fill="#87083C" />
    <path
      d="M40.04 57.4c-.69-.4-1.81-.4-2.5 0-.7.39-.7 1.04 0 1.44.69.4 1.81.4 2.5 0 .7-.4.7-1.05 0-1.45Z"
      fill="#DB8C19"
    />
    <path
      d="M41.01 60.36c-1.22.7-3.22.7-4.44 0-.3-.17-.52-.36-.67-.57l.02.15c.16.2.37.38.65.54 1.22.7 3.22.7 4.44 0 .28-.16.5-.34.65-.54l.02-.15c-.15.2-.38.4-.67.57Z"
      fill="#DB8C19"
      opacity=".7"
    />
    <path
      d="M41.59 60.18a2.3 2.3 0 0 1-.58.46c-1.22.7-3.22.7-4.44 0-.24-.14-.43-.3-.58-.46l.1.24c.14.12.3.24.48.35 1.22.7 3.22.7 4.44 0 .18-.11.34-.23.47-.35.04-.08.08-.16.1-.24Z"
      fill="#DB8C19"
      opacity=".7"
    />
    <path
      d="M41.22 60.79a4.92 4.92 0 0 1-4.87 0c.11.12.23.24.37.34a5 5 0 0 0 4.14 0c.13-.1.26-.22.36-.34Z"
      fill="#DB8C19"
      opacity=".7"
    />
    <path
      d="M39.96 57.37a2.6 2.6 0 0 0-2.34 0c-.64.37-.64.98 0 1.35.64.37 1.7.37 2.34 0 .64-.37.64-.98 0-1.35Z"
      fill="#D8741A"
    />
    <path
      d="M37.62 58.72c.64.37 1.7.37 2.34 0 .64-.37.64-.98 0-1.35"
      fill="#C96717"
    />
    <path
      d="M38.24 58.94c.36.08.75.08 1.1 0v-1.1l-1.1.25v.85Z"
      fill="#C96717"
      opacity=".3"
    />
    <path
      d="M38.4 58.3c-.38 0-.76-.27-.76-.89 0-.66.45-1.44 1.02-1.77.42-.24.85-.2 1.09.1a1 1 0 0 1 .2.64c0 .66-.46 1.44-1.03 1.77-.18.1-.36.16-.53.16Zm.79-2.3a.56.56 0 0 0-.27.09 1.7 1.7 0 0 0-.77 1.32c0 .12.03.38.24.38.08 0 .17-.03.27-.08.42-.24.77-.85.77-1.33a.5.5 0 0 0-.09-.3.19.19 0 0 0-.15-.08Z"
      fill="#F7A23C"
    />
    <path
      d="M39.94 56.38a.99.99 0 0 0-.2-.63.68.68 0 0 0-.3-.22c-.08.03-.17.06-.25.11-.5.28-.89.89-1 1.47.1-.4.4-.83.73-1.02.1-.06.19-.09.27-.09.07 0 .12.02.15.07a.5.5 0 0 1 .09.3c0 .49-.35 1.1-.77 1.33-.1.06-.19.1-.27.1-.12 0-.18-.1-.21-.2.05.37.25.58.49.66.08-.02.17-.06.25-.1a2.23 2.23 0 0 0 1.02-1.78Z"
      fill="#E59120"
    />
    <path
      d="M43.25 62c-5.95-3.44-5.98-9.04-.05-12.46 5.92-3.42 15.6-3.42 21.53 0 5.92 3.42 5.94 9.02.05 12.46-5.89 3.44-15.58 3.44-21.53 0Z"
      fill="#3E9306"
    />
    <path
      d="M43.25 62c-5.95-3.44-5.98-9.04-.05-12.46 5.92-3.42 15.6-3.42 21.53 0"
      fill="#98D80B"
    />
    <path d="M53.98 26.66v28.01l-15.19-.47 15.19-27.54Z" fill="#98D80B" />
    <path d="m53.98 26.66-6.09 36.66 21.27-9.12-15.18-27.54Z" fill="#3E9306" />
    <path d="m53.98 26.66 6.7 22.14 8.48 5.4-15.18-27.54Z" fill="#158E0C" />
    <path
      d="M44.92 49.8c-5.03-2.9-5.05-7.63-.05-10.52 5-2.89 13.19-2.89 18.19 0 5 2.89 5.02 7.62.04 10.52-4.97 2.9-13.15 2.9-18.18 0Z"
      fill="#4DA004"
    />
    <path
      d="M44.92 49.8c-5.03-2.9-5.05-7.63-.05-10.52 5-2.89 13.19-2.89 18.19 0"
      fill="#98D80B"
    />
    <path d="M53.98 19.95v23.67l-12.83-.4 12.83-23.27Z" fill="#98D80B" />
    <path d="m53.98 19.95-5.14 30.97 17.97-7.7-12.83-23.27Z" fill="#4DA004" />
    <path d="m53.98 19.95 5.66 18.7 7.17 4.57-12.83-23.27Z" fill="#158E0C" />
    <path
      d="M47.69 36.64c-3.5-2.02-3.5-5.3-.04-7.31 3.48-2 9.16-2 12.63 0 3.47 2 3.49 5.3.03 7.3-3.45 2.02-9.13 2.02-12.62 0Z"
      fill="#3E9306"
    />
    <path
      d="M47.69 36.64c-3.5-2.02-3.5-5.3-.04-7.31 3.48-2 9.16-2 12.63 0"
      fill="#98D80B"
    />
    <path d="M53.98 15.91v16.43l-8.9-.28 8.9-16.15Z" fill="#98D80B" />
    <path d="m53.98 15.91-3.57 21.5 12.47-5.35-8.9-16.15Z" fill="#3E9306" />
    <path d="M53.98 15.91 57.9 28.9l4.97 3.17-8.9-16.15Z" fill="#158E0C" />
    <path
      d="M49.26 26.98c-2.61-1.51-2.62-3.97-.02-5.48a10.5 10.5 0 0 1 9.46 0c2.6 1.5 2.61 3.97.03 5.48-2.6 1.5-6.85 1.5-9.47 0Z"
      fill="#4DA004"
    />
    <path
      d="M49.26 26.98c-2.61-1.51-2.62-3.97-.02-5.48a10.5 10.5 0 0 1 9.46 0"
      fill="#98D80B"
    />
    <path d="M53.98 11.45v12.3l-6.68-.2 6.68-12.1Z" fill="#98D80B" />
    <path d="M53.98 11.45 51.3 27.56l9.35-4-6.67-12.11Z" fill="#4DA004" />
    <path d="m53.98 11.45 2.94 9.73 3.73 2.37-6.67-12.1Z" fill="#158E0C" />
    <path
      d="M53.98 13.08a.36.36 0 0 1-.36-.36V6.43a.36.36 0 1 1 .72 0v6.29c0 .2-.16.36-.36.36Z"
      fill="#158E0C"
    />
    <path
      d="m55.63 6.97 2.28-4.93-1.1-.63c-.1-.07-.28-.04-.54.11l-.63.36a.94.94 0 0 1-.95.03l.12-1.24-1.12-.64c-.16-.1-.32.05-.43.44l-.6 2.2a3.27 3.27 0 0 1-1.33 1.7l-1.67.98c-.56.32-.56.84 0 1.16l.44.26c.56.32.92 1.1.8 1.72l-.43 2.47c-.05.31-.02.5.07.53v.02l1.11.62.99-2.6 2.2-1.21.11.04c.6.23.97-.1.83-.72l-.15-.67Z"
      fill="#C68A12"
    />
    <path
      d="m53.76 4.31.94-2.5.1-1.14-1.1-.64c-.16-.1-.32.05-.43.44l-.6 2.2a3 3 0 0 1-.4.8l1.5.84Zm-3.22 7.19 1.11.63.99-2.6.42-.24-2.15-1.24c.02.15.02.3 0 .44l-.44 2.47c-.05.31-.02.5.07.53Z"
      fill="#AF7510"
    />
    <path
      d="M57.87 2.62c.28-.57.06-.78-.5-.46l-.62.36A.92.92 0 0 1 55.37 2l-.31-.91c-.2-.61-.52-.6-.69.02l-.6 2.2a3.27 3.27 0 0 1-1.33 1.7l-1.67.97c-.56.32-.56.85 0 1.17l.44.26c.56.32.92 1.1.8 1.72l-.43 2.47c-.11.63.12.73.51.22l1.87-2.43c.4-.5 1.2-.73 1.8-.5l.3.1c.6.23.97-.1.83-.72l-.32-1.37a3.8 3.8 0 0 1 .26-2.18l1.04-2.1Z"
      fill="#EFC411"
    />
    <path
      d="m57.37 2.16-.62.36A.92.92 0 0 1 55.37 2l-.31-.91c-.2-.61-.52-.6-.69.02l-.6 2.2a3.27 3.27 0 0 1-1.33 1.7l-1.67.97c-.56.32-.56.85 0 1.17l.44.26c.56.32.92 1.1.8 1.72l-.43 2.47c-.11.63.12.73.51.22l1.87-2.43 2.87-4.67 1.04-2.1c.28-.57.06-.78-.5-.46Z"
      fill="#E5BA05"
    />
    <path
      d="M44.9 53.9a1.85 1.85 0 1 0 0-3.7 1.85 1.85 0 0 0 0 3.7Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M45.77 52.06a.88.88 0 1 1-1.62-.66c.18-.45.8-.94 1.25-.76.45.18.56.97.37 1.42Z"
      fill="#FFA300"
    />
    <path
      d="M45.26 50.68c-.15-.06-.24-.05-.43.03-.24.07-.57.44-.68.7a.87.87 0 0 0 .93 1.19.87.87 0 0 0 .55-.5c.18-.46.08-1.24-.37-1.42Z"
      fill="#FFB600"
    />
    <path
      d="M44.83 50.7c-.24.08-.57.45-.68.7a.87.87 0 0 0 .93 1.2"
      fill="#FFC200"
    />
    <path
      d="M45.85 51.46c-.02-.35-.17-.7-.45-.82-.27-.11-.62.04-.89.28a.4.4 0 0 0 .11.23c.2.28.66.46 1 .4.1 0 .18-.04.23-.09Z"
      fill="#FFA300"
    />
    <path
      d="m45.82 51.11-1.04-.42-.03.09v-.02.03c-.03.07-.01.16.06.26.16.2.49.33.73.3.12-.02.2-.07.24-.14v-.02l.04-.08Z"
      fill="#232B2A"
    />
    <path
      d="M44.81 51.05c.16.2.49.33.73.3.12-.02.2-.07.24-.14v-.02l.04-.08-.89-.36-.12.3Z"
      fill="#000"
    />
    <path
      d="M45.75 50.84a.87.87 0 0 0-.73-.3c-.25.04-.33.24-.18.43.16.2.49.33.74.3.25-.03.33-.23.17-.43Z"
      fill="#2D3534"
    />
    <path d="M45.75 50.84a.87.87 0 0 0-.73-.3l.73.3Z" fill="#C7D8D5" />
    <path
      d="M44.84 50.97c.16.2.49.33.74.3.25-.03.33-.23.17-.43"
      fill="#232B2A"
    />
    <path
      d="M45.68 50.85a.75.75 0 0 0-.62-.26c-.21.04-.28.2-.15.37.13.17.41.28.63.25.21-.02.28-.19.14-.36Z"
      fill="#90AFAD"
    />
    <path
      d="M45.66 50.87a.7.7 0 0 0-.6-.24c-.2.03-.26.19-.13.34a.7.7 0 0 0 .59.24c.2-.02.26-.18.14-.34Z"
      fill="#7A9E9A"
    />
    <path
      d="M44.93 50.97c.12.17.39.27.59.24.2-.02.26-.18.14-.34"
      fill="#6A918B"
    />
    <path
      d="m45.78 51.01-.9-.36-.03.07v-.01.02c-.02.06-.01.15.06.23.13.17.42.29.63.26.1-.02.18-.07.2-.13l.01-.01.03-.07Z"
      fill="#232B2A"
    />
    <path
      d="M44.9 50.96a.8.8 0 0 0 .64.26c.1-.02.18-.07.2-.13l.01-.01.03-.07-.77-.31-.1.26Z"
      fill="#000"
    />
    <path
      d="M45.72 50.78a.74.74 0 0 0-.64-.26c-.21.04-.28.2-.15.37.14.18.42.3.64.26.21-.03.28-.2.15-.37Z"
      fill="#2D3534"
    />
    <path d="M45.72 50.78a.74.74 0 0 0-.64-.26l.64.26Z" fill="#414C4A" />
    <path
      d="M44.93 50.9a.8.8 0 0 0 .64.25c.21-.03.28-.2.15-.37"
      fill="#232B2A"
    />
    <path
      d="M45.66 50.79a.64.64 0 0 0-.54-.22c-.19.02-.25.17-.13.31.12.15.36.25.54.22.19-.02.25-.16.13-.31Z"
      fill="#000"
    />
    <path
      d="M45.64 50.8a.61.61 0 0 0-.52-.2c-.17.02-.22.15-.12.3.11.13.34.23.51.2.18-.03.23-.16.13-.3Z"
      fill="#2B3332"
    />
    <path d="M45 50.9c.11.13.34.22.51.2.18-.03.23-.16.13-.3" fill="#232B2A" />
    <path
      d="m46 50.26-.75-.3-.24.59v.01c-.02.06 0 .12.05.2.1.13.34.23.52.2.09-.01.14-.05.17-.1l.24-.6Z"
      fill="#A4BCBB"
    />
    <path
      d="M45.02 50.62v.02l-.01.03c0 .03.02.05.05.08.1.15.34.24.52.21.09-.01.14-.05.17-.1l.24-.6-.7-.3-.27.66Z"
      fill="#74918E"
    />
    <path
      d="m45.05 50.69-.01.01v.02l.02.03c.1.14.34.24.52.21.09-.01.14-.05.17-.1l.24-.6-.66-.27-.28.7Z"
      fill="#526D6A"
    />
    <path
      d="M45.3 50.88v.02l-.01.01v.01c.1.04.2.05.3.04a.2.2 0 0 0 .16-.1l.24-.6-.37-.16-.32.78Z"
      fill="#3C5652"
    />
    <path
      d="M45.95 50.05a.62.62 0 0 0-.52-.22c-.18.03-.24.16-.13.31.1.12.29.2.45.21h.08c.18-.03.23-.16.12-.3Z"
      fill="#BCCECC"
    />
    <path
      d="M45.3 50.14c.1.12.29.2.45.21h.08c.18-.03.23-.16.12-.3"
      fill="#A4BCBB"
    />
    <path
      d="M50.11 53.95a1.85 1.85 0 1 1-3.43-1.38 1.85 1.85 0 0 1 3.43 1.38Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M49.28 53.27a.87.87 0 1 1-1.62-.66c.18-.44.8-.93 1.25-.75.45.18.55.96.37 1.41Z"
      fill="#FFA300"
    />
    <path
      d="M48.76 51.9c-.14-.07-.23-.06-.43.02-.24.08-.57.45-.67.7a.87.87 0 0 0 .93 1.2.87.87 0 0 0 .55-.52c.18-.44.07-1.22-.38-1.4Z"
      fill="#FFB600"
    />
    <path
      d="M48.33 51.92c-.24.08-.57.45-.67.7a.87.87 0 0 0 .93 1.2"
      fill="#FFC200"
    />
    <path
      d="M49.36 52.67c-.02-.36-.17-.7-.45-.81-.28-.11-.63.03-.9.27.01.08.04.16.11.24.2.27.66.46 1 .4.1 0 .18-.05.24-.1Z"
      fill="#FFA300"
    />
    <path
      d="m49.32 52.32-1.04-.42-.03.09v-.02.03c-.03.08 0 .17.06.27.16.2.49.32.74.3.12-.02.2-.08.23-.15l.01-.01.03-.09Z"
      fill="#232B2A"
    />
    <path
      d="M48.31 52.27c.16.2.49.33.74.3.12-.02.2-.08.23-.15l.01-.01.03-.09-.88-.36-.13.3Z"
      fill="#000"
    />
    <path
      d="M49.25 52.06a.92.92 0 0 0-.73-.3c-.25.03-.33.23-.17.42.15.2.48.34.73.3.25-.03.33-.23.17-.42Z"
      fill="#2D3534"
    />
    <path d="M49.25 52.06a.92.92 0 0 0-.73-.3l.73.3Z" fill="#C7D8D5" />
    <path
      d="M48.35 52.18c.15.2.48.34.73.3.25-.03.33-.23.18-.42"
      fill="#232B2A"
    />
    <path
      d="M49.19 52.07a.76.76 0 0 0-.63-.26c-.21.04-.28.2-.15.36.14.17.42.29.63.26.21-.03.28-.19.15-.36Z"
      fill="#90AFAD"
    />
    <path
      d="M49.16 52.09a.7.7 0 0 0-.6-.24c-.19.03-.25.18-.13.34a.7.7 0 0 0 .59.24c.2-.03.26-.19.14-.34Z"
      fill="#7A9E9A"
    />
    <path
      d="M48.43 52.19a.7.7 0 0 0 .6.24c.19-.03.25-.19.13-.34"
      fill="#6A918B"
    />
    <path
      d="m49.28 52.23-.9-.37-.03.08.01-.02v.01l-.01.02c-.02.06 0 .14.06.22.13.18.42.3.64.26.1-.01.17-.06.2-.12v-.02l.03-.06Z"
      fill="#232B2A"
    />
    <path
      d="M48.41 52.17c.13.18.42.3.64.26.1-.01.17-.06.2-.12v-.02l.03-.06-.77-.31-.1.25Z"
      fill="#000"
    />
    <path
      d="M49.22 52a.75.75 0 0 0-.63-.26c-.22.03-.29.2-.15.37.13.17.42.28.63.25.22-.02.29-.2.15-.37Z"
      fill="#2D3534"
    />
    <path d="M49.22 52a.75.75 0 0 0-.63-.26l.63.25Z" fill="#414C4A" />
    <path
      d="M48.44 52.1c.13.18.42.3.63.26.22-.02.29-.2.15-.37"
      fill="#232B2A"
    />
    <path
      d="M49.16 52a.7.7 0 0 0-.54-.22c-.18.03-.24.17-.12.31.1.15.35.25.54.22.18-.02.24-.16.12-.3Z"
      fill="#000"
    />
    <path
      d="M49.14 52.02a.62.62 0 0 0-.51-.2c-.18.01-.23.15-.12.29.1.14.34.23.5.2.18-.02.24-.15.13-.3Z"
      fill="#2B3332"
    />
    <path
      d="M48.5 52.11a.6.6 0 0 0 .52.2c.17-.02.23-.15.12-.3"
      fill="#232B2A"
    />
    <path
      d="m49.5 51.47-.75-.3-.24.6v.01c-.02.05 0 .12.05.19.1.14.35.23.52.2.09 0 .15-.04.17-.09l.25-.6Z"
      fill="#A4BCBB"
    />
    <path
      d="M48.52 51.84v.04c0 .03.02.06.04.09.1.14.35.23.52.21.09-.01.15-.05.17-.1l.25-.6-.71-.3-.27.66Z"
      fill="#74918E"
    />
    <path
      d="m48.55 51.9-.01.03.02.04c.1.14.34.23.52.21.09-.01.15-.05.17-.1l.25-.6-.67-.27-.28.7Z"
      fill="#526D6A"
    />
    <path
      d="M48.8 52.09v.04c.09.04.2.06.28.05.09-.01.15-.05.17-.1l.25-.6-.38-.16-.31.77Z"
      fill="#3C5652"
    />
    <path
      d="M49.46 51.26a.63.63 0 0 0-.53-.21c-.18.02-.24.16-.12.3.1.12.28.22.44.22h.08c.18-.03.24-.17.13-.3Z"
      fill="#BCCECC"
    />
    <path
      d="M48.8 51.35c.1.12.29.22.45.22h.08c.18-.03.24-.17.13-.3"
      fill="#A4BCBB"
    />
    <path
      d="M54.46 53.81a1.85 1.85 0 1 1-3.43-1.39 1.85 1.85 0 0 1 3.43 1.4Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M53.62 53.14a.87.87 0 0 1-1.13.48.87.87 0 0 1-.49-1.14c.18-.45.8-.94 1.25-.75.45.18.56.96.37 1.41Z"
      fill="#FFA300"
    />
    <path
      d="M53.11 51.75c-.14-.06-.23-.05-.43.03a1.5 1.5 0 0 0-.68.7.87.87 0 0 0 .94 1.2.86.86 0 0 0 .54-.5c.19-.46.08-1.24-.37-1.43Z"
      fill="#FFB600"
    />
    <path
      d="M52.68 51.78a1.5 1.5 0 0 0-.68.7.87.87 0 0 0 .94 1.2"
      fill="#FFC200"
    />
    <path
      d="M53.7 52.54c-.02-.36-.17-.7-.45-.81-.28-.12-.62.03-.89.27.01.07.04.16.11.24.2.27.65.45 1 .4.1-.01.18-.05.23-.1Z"
      fill="#FFA300"
    />
    <path
      d="m53.67 52.19-1.04-.42-.03.09v-.02.02c-.03.08-.01.18.06.27.16.2.49.33.73.3.12-.02.2-.07.24-.15v-.01l.04-.08Z"
      fill="#232B2A"
    />
    <path
      d="M52.66 52.13c.16.2.49.33.73.3.12-.02.2-.07.24-.15v-.01l.04-.08-.88-.36-.13.3Z"
      fill="#000"
    />
    <path
      d="M53.6 51.93a.85.85 0 0 0-.73-.3c-.25.03-.33.22-.17.42.15.2.48.33.73.3.25-.04.32-.23.17-.42Z"
      fill="#2D3534"
    />
    <path d="M53.6 51.93a.85.85 0 0 0-.73-.3l.73.3Z" fill="#C7D8D5" />
    <path
      d="M52.7 52.05c.15.2.48.33.73.3.25-.04.32-.23.17-.42"
      fill="#232B2A"
    />
    <path
      d="M53.54 51.93a.73.73 0 0 0-.63-.25c-.21.03-.28.2-.15.36.13.17.42.29.63.26.21-.03.28-.2.15-.37Z"
      fill="#90AFAD"
    />
    <path
      d="M53.5 51.95a.73.73 0 0 0-.58-.24c-.2.03-.27.18-.14.34a.7.7 0 0 0 .59.24c.2-.03.26-.17.14-.34Z"
      fill="#7A9E9A"
    />
    <path
      d="M52.78 52.05a.7.7 0 0 0 .59.24c.2-.03.26-.17.14-.34"
      fill="#6A918B"
    />
    <path
      d="m53.63 52.09-.9-.37-.03.08v-.01.02c-.02.07 0 .15.06.23.13.17.42.29.63.26.1-.01.18-.06.2-.12l.02-.02.02-.07Z"
      fill="#232B2A"
    />
    <path
      d="M52.76 52.04c.13.17.42.29.63.26.1-.01.18-.06.2-.12l.02-.02.02-.07-.77-.31-.1.26Z"
      fill="#000"
    />
    <path
      d="M53.57 51.86a.78.78 0 0 0-.64-.26c-.21.03-.28.2-.15.37.14.17.42.29.64.26.22-.03.28-.2.15-.37Z"
      fill="#2D3534"
    />
    <path d="M53.57 51.86a.78.78 0 0 0-.64-.26l.64.26Z" fill="#414C4A" />
    <path
      d="M52.78 51.97c.14.17.42.29.64.26.22-.03.28-.2.15-.37"
      fill="#232B2A"
    />
    <path
      d="M53.51 51.87a.65.65 0 0 0-.54-.22c-.19.03-.24.16-.13.3.12.16.36.26.55.23.18-.02.24-.16.12-.31Z"
      fill="#000"
    />
    <path
      d="M53.49 51.88a.65.65 0 0 0-.51-.2c-.18.02-.23.15-.12.3.1.13.33.22.5.2.18-.02.24-.16.13-.3Z"
      fill="#2B3332"
    />
    <path
      d="M52.86 51.97c.1.14.33.23.5.2.18-.01.24-.15.13-.29"
      fill="#232B2A"
    />
    <path
      d="m53.85 51.33-.75-.3-.24.6v.02c-.02.05 0 .11.05.18.1.15.34.24.52.21.09 0 .14-.04.17-.1l.25-.6Z"
      fill="#A4BCBB"
    />
    <path
      d="M52.87 51.7v.01l-.01.04.05.08c.1.15.34.24.52.21.09 0 .14-.04.17-.1l.25-.6-.71-.3-.27.66Z"
      fill="#74918E"
    />
    <path
      d="M52.9 51.77v.01l-.01.02c0 .02 0 .02.02.03.1.14.34.24.52.21.09 0 .14-.04.17-.1l.25-.6-.67-.27-.28.7Z"
      fill="#526D6A"
    />
    <path
      d="M53.15 51.96V52c.09.04.2.05.28.04.09 0 .14-.04.17-.1l.25-.6-.38-.16-.32.78Z"
      fill="#3C5652"
    />
    <path
      d="M53.8 51.13a.63.63 0 0 0-.52-.21c-.18.02-.24.15-.12.3.09.12.28.2.44.22l.08-.01c.18-.03.23-.16.12-.3Z"
      fill="#BCCECC"
    />
    <path
      d="M53.16 51.22c.09.12.28.2.44.21h.08c.18-.03.23-.16.13-.3"
      fill="#A4BCBB"
    />
    <path
      d="M58.5 52.6a1.85 1.85 0 1 1-3.44-1.39 1.85 1.85 0 0 1 3.43 1.39Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M57.66 51.92a.87.87 0 0 1-1.14.48.87.87 0 0 1-.48-1.14c.18-.45.8-.94 1.25-.75.45.18.55.96.37 1.4Z"
      fill="#FFA300"
    />
    <path
      d="M57.15 50.54c-.15-.06-.24-.05-.43.03-.24.07-.58.44-.68.7-.18.44.03.95.48 1.13.15.06.3.08.45.06a.87.87 0 0 0 .55-.5c.18-.45.08-1.24-.37-1.42Z"
      fill="#FFB600"
    />
    <path
      d="M56.72 50.57c-.24.07-.58.44-.68.7-.18.44.03.95.48 1.13.15.06.3.08.45.06"
      fill="#FFC200"
    />
    <path
      d="M57.74 51.32c-.03-.35-.17-.7-.45-.81-.28-.12-.63.04-.9.26.02.08.05.17.12.25.2.27.65.45.99.4a.4.4 0 0 0 .24-.1Z"
      fill="#FFA300"
    />
    <path
      d="m57.7 50.97-1.03-.42-.04.09v-.02.03c-.03.07 0 .17.07.26.15.2.48.33.73.3.12-.02.2-.07.24-.14v-.02l.04-.08Z"
      fill="#232B2A"
    />
    <path
      d="M56.7 50.91c.15.2.48.33.73.3.12-.02.2-.07.24-.14v-.02l.04-.08-.89-.36-.12.3Z"
      fill="#000"
    />
    <path
      d="M57.64 50.7a.91.91 0 0 0-.74-.3c-.25.04-.32.23-.17.43.16.2.49.33.74.3.24-.03.32-.23.17-.42Z"
      fill="#2D3534"
    />
    <path d="M57.64 50.7a.91.91 0 0 0-.74-.3l.74.3Z" fill="#C7D8D5" />
    <path
      d="M56.73 50.83c.16.2.49.33.74.3.24-.03.32-.23.17-.42"
      fill="#232B2A"
    />
    <path
      d="M57.57 50.72a.74.74 0 0 0-.63-.26c-.2.03-.27.2-.14.36.13.17.41.28.63.26.2-.03.27-.2.14-.36Z"
      fill="#90AFAD"
    />
    <path
      d="M57.54 50.73a.7.7 0 0 0-.59-.24c-.2.03-.26.18-.14.34.13.16.4.27.6.24.2-.03.26-.18.13-.34Z"
      fill="#7A9E9A"
    />
    <path
      d="M56.81 50.83c.13.16.4.27.6.24.2-.03.26-.18.13-.34"
      fill="#6A918B"
    />
    <path
      d="m57.67 50.87-.9-.37-.03.08v.01c-.03.07-.01.15.05.23.14.17.42.29.64.26.1-.02.17-.06.2-.13l.01-.01.03-.07Z"
      fill="#232B2A"
    />
    <path
      d="M56.8 50.82c.13.17.41.3.63.26.1-.02.17-.06.2-.12l.01-.02.03-.07-.77-.31-.1.26Z"
      fill="#000"
    />
    <path
      d="M57.6 50.65a.71.71 0 0 0-.63-.26c-.21.02-.28.19-.15.36.13.18.42.3.64.26.21-.03.28-.2.14-.36Z"
      fill="#2D3534"
    />
    <path d="M57.6 50.65a.71.71 0 0 0-.63-.26l.63.26Z" fill="#414C4A" />
    <path
      d="M56.82 50.75c.13.18.42.3.64.26.21-.03.28-.2.14-.36"
      fill="#232B2A"
    />
    <path
      d="M57.55 50.65a.63.63 0 0 0-.54-.22c-.19.03-.25.17-.13.31.11.15.36.25.54.22.19-.02.24-.16.13-.3Z"
      fill="#000"
    />
    <path
      d="M57.52 50.67a.63.63 0 0 0-.5-.21c-.18.03-.23.15-.13.3.11.14.34.23.51.2.18-.02.23-.15.12-.3Z"
      fill="#2B3332"
    />
    <path d="M56.9 50.75c.1.15.33.24.5.21.18-.02.23-.15.12-.3" fill="#232B2A" />
    <path
      d="m57.88 50.12-.74-.3-.25.6c-.02.06 0 .12.05.19.11.14.35.24.53.21.08 0 .14-.04.17-.1l.24-.6Z"
      fill="#A4BCBB"
    />
    <path
      d="M56.9 50.48v.05c0 .03.02.05.04.08.11.14.35.24.53.21.08 0 .14-.04.17-.1l.24-.6-.7-.29-.27.65Z"
      fill="#74918E"
    />
    <path
      d="M56.93 50.55v.03l.01.03c.11.14.35.24.53.21.08 0 .14-.04.17-.1l.24-.6-.66-.27-.29.7Z"
      fill="#526D6A"
    />
    <path
      d="M57.2 50.73h-.01v.03l-.01.02c.1.04.2.06.29.04.08 0 .14-.04.17-.1l.24-.6-.38-.16-.3.77Z"
      fill="#3C5652"
    />
    <path
      d="M57.84 49.91a.59.59 0 0 0-.53-.21c-.17.01-.23.15-.12.3.1.12.28.2.45.21h.08c.18-.02.23-.16.12-.3Z"
      fill="#BCCECC"
    />
    <path
      d="M57.19 50c.1.12.28.2.45.21h.08c.18-.02.23-.16.12-.3"
      fill="#A4BCBB"
    />
    <path
      d="M61.73 51.03a1.85 1.85 0 1 1-3.58-.91 1.85 1.85 0 0 1 3.58.91Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M60.81 50.47a.87.87 0 0 1-1.06.64.88.88 0 0 1-.63-1.06c.12-.47.67-1.04 1.14-.93.46.12.67.89.55 1.35Z"
      fill="#FFA300"
    />
    <path
      d="M60.12 49.17c-.16-.03-.24-.01-.43.1-.22.1-.5.52-.57.78a.88.88 0 0 0 1.09 1.05c.22-.1.4-.3.47-.57.12-.47-.1-1.23-.56-1.36Z"
      fill="#FFB600"
    />
    <path
      d="M59.7 49.26c-.23.11-.52.53-.58.79a.88.88 0 0 0 1.09 1.05"
      fill="#FFC200"
    />
    <path
      d="M60.81 49.87c-.07-.35-.26-.67-.55-.75-.3-.07-.62.12-.85.4.01.07.06.14.14.22.24.24.7.36 1.03.27.1-.03.18-.08.23-.14Z"
      fill="#FFA300"
    />
    <path
      d="m60.73 49.52-1.09-.27-.02.1.01-.02v.02c-.02.08 0 .18.1.26a.9.9 0 0 0 .76.2c.12-.04.19-.1.21-.18v-.02l.03-.09Z"
      fill="#232B2A"
    />
    <path
      d="M59.72 49.61c.18.17.53.26.77.2.12-.04.19-.1.21-.18v-.02l.03-.09-.93-.23-.08.32Z"
      fill="#000"
    />
    <path
      d="M60.62 49.28a.87.87 0 0 0-.76-.2c-.25.07-.3.27-.12.45a.9.9 0 0 0 .77.19c.24-.07.3-.27.11-.44Z"
      fill="#2D3534"
    />
    <path d="M60.62 49.28a.86.86 0 0 0-.76-.2l.76.2Z" fill="#C7D8D5" />
    <path
      d="M59.74 49.53a.9.9 0 0 0 .77.19c.24-.07.3-.27.11-.44"
      fill="#232B2A"
    />
    <path
      d="M60.56 49.3a.8.8 0 0 0-.65-.18c-.21.07-.25.24-.1.39.15.15.45.22.65.16.21-.06.26-.23.1-.38Z"
      fill="#90AFAD"
    />
    <path
      d="M60.53 49.32a.7.7 0 0 0-.61-.15c-.2.04-.24.2-.1.35.15.13.43.2.62.15.2-.05.24-.21.1-.35Z"
      fill="#7A9E9A"
    />
    <path
      d="M59.83 49.52c.14.13.42.2.61.15.2-.05.24-.21.1-.35"
      fill="#6A918B"
    />
    <path
      d="m60.68 49.44-.95-.24-.02.08.01-.02v.03c-.02.06 0 .14.08.22.16.15.46.23.67.17.1-.03.16-.08.18-.15l.01-.02.02-.07Z"
      fill="#232B2A"
    />
    <path
      d="M59.8 49.5c.16.16.46.24.67.18.1-.03.16-.09.18-.15v-.02l.03-.07-.8-.2-.08.27Z"
      fill="#000"
    />
    <path
      d="M60.58 49.22a.74.74 0 0 0-.66-.17c-.21.06-.26.23-.1.38s.46.23.67.17c.2-.06.25-.22.1-.38Z"
      fill="#2D3534"
    />
    <path d="M60.58 49.22a.74.74 0 0 0-.66-.17l.66.17Z" fill="#414C4A" />
    <path
      d="M59.82 49.43c.16.15.46.23.67.17.2-.06.25-.22.1-.38"
      fill="#232B2A"
    />
    <path
      d="M60.53 49.23a.62.62 0 0 0-.57-.13c-.18.04-.22.19-.08.31.13.14.39.2.57.15.17-.05.21-.2.08-.33Z"
      fill="#000"
    />
    <path
      d="M60.5 49.26a.62.62 0 0 0-.53-.14c-.17.04-.2.18-.08.3.13.13.37.18.54.14.17-.05.2-.19.08-.3Z"
      fill="#2B3332"
    />
    <path
      d="M59.9 49.42c.12.13.36.18.53.14.17-.05.2-.19.08-.3"
      fill="#232B2A"
    />
    <path
      d="m60.79 48.66-.78-.2-.16.63v.01c-.01.05.02.12.07.18.13.12.38.19.56.14.08-.03.12-.06.14-.12l.17-.64Z"
      fill="#A4BCBB"
    />
    <path
      d="M59.87 49.15v.05l.05.08c.13.12.38.19.56.14.08-.03.12-.06.14-.13l.17-.63-.74-.19-.18.68Z"
      fill="#74918E"
    />
    <path
      d="M59.9 49.22v.03l.02.03c.13.12.38.19.56.14.08-.03.12-.06.14-.12l.16-.64-.69-.18-.18.74Z"
      fill="#526D6A"
    />
    <path
      d="M60.19 49.36v.05c.1.03.2.03.29 0 .08-.02.12-.05.14-.11l.17-.64-.4-.1-.2.8Z"
      fill="#3C5652"
    />
    <path
      d="M60.72 48.46a.62.62 0 0 0-.56-.14c-.16.04-.2.2-.07.31.1.11.3.17.47.16l.08-.02c.17-.05.2-.19.08-.31Z"
      fill="#BCCECC"
    />
    <path
      d="M60.09 48.63c.1.11.3.17.47.16l.08-.02c.17-.05.2-.19.08-.31"
      fill="#A4BCBB"
    />
    <path
      d="M41.26 46.94s.31.33.93.82a15.03 15.03 0 0 0 7.06 3.1c.82.12 1.67.15 2.55.12.86-.06 1.75-.16 2.6-.38a19.66 19.66 0 0 0 4.86-1.85c.39-.18.73-.4 1.08-.6.35-.21.7-.41 1-.63l.94-.62.84-.63c.55-.4 1.03-.8 1.45-1.14.44-.33.8-.65 1.09-.91l.94-.82-.86.9c-.28.29-.61.63-1.02 1-.4.38-.85.82-1.38 1.23l-.83.68-.91.67c-.32.24-.65.45-1 .68a20.78 20.78 0 0 1-3.46 1.8 16.07 16.07 0 0 1-5.32 1.18c-.9.01-1.8-.03-2.65-.17a13.43 13.43 0 0 1-7.06-3.52 8.22 8.22 0 0 1-.85-.91Z"
      fill="#547277"
    />
    <path
      d="M47.72 39.41a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M48.35 38.12a.62.62 0 1 1-1.14-.46c.12-.32.56-.66.88-.53.31.12.39.68.26 1Z"
      fill="#FFA300"
    />
    <path
      d="M47.98 37.15c-.1-.04-.16-.04-.3.02-.17.05-.4.31-.47.49a.62.62 0 0 0 .65.84.6.6 0 0 0 .39-.35c.13-.32.05-.87-.27-1Z"
      fill="#FFB600"
    />
    <path
      d="M47.68 37.17c-.17.05-.4.31-.47.49a.62.62 0 0 0 .65.84"
      fill="#FFC200"
    />
    <path
      d="M48.4 37.7c-.01-.25-.12-.5-.31-.57-.2-.08-.45.02-.63.19 0 .05.03.11.07.17.15.19.47.32.7.28a.3.3 0 0 0 .17-.07Z"
      fill="#FFA300"
    />
    <path
      d="m48.38 37.46-.73-.3-.03.06v-.01.02c-.02.05 0 .12.05.19.1.13.34.22.51.2.09-.01.15-.05.17-.1l.03-.06Z"
      fill="#232B2A"
    />
    <path
      d="M47.67 37.42c.1.13.34.22.51.2.09-.01.15-.05.17-.1l.03-.06-.63-.26-.08.22Z"
      fill="#000"
    />
    <path
      d="M48.33 37.27a.61.61 0 0 0-.52-.21c-.17.02-.23.16-.12.3a.6.6 0 0 0 .52.2c.17-.01.23-.15.12-.3Z"
      fill="#2D3534"
    />
    <path d="M48.33 37.27a.6.6 0 0 0-.52-.21l.52.2Z" fill="#C7D8D5" />
    <path d="M47.7 37.36c.1.14.33.23.5.2.18-.01.24-.15.13-.3" fill="#232B2A" />
    <path
      d="M48.28 37.27a.53.53 0 0 0-.44-.18c-.15.03-.2.14-.1.26s.29.2.44.18c.15-.02.2-.14.1-.26Z"
      fill="#90AFAD"
    />
    <path
      d="M48.26 37.29a.49.49 0 0 0-.41-.17c-.14.02-.19.13-.1.24.09.11.28.19.42.17.14-.02.18-.13.1-.24Z"
      fill="#7A9E9A"
    />
    <path
      d="M47.75 37.36c.09.11.28.19.42.17.14-.02.18-.13.1-.24"
      fill="#6A918B"
    />
    <path
      d="m48.35 37.39-.63-.26-.02.05c-.02.05-.01.11.04.17.09.12.3.2.44.18.07 0 .13-.04.15-.09l.02-.05Z"
      fill="#232B2A"
    />
    <path
      d="M47.74 37.35c.09.12.3.2.44.18.07 0 .13-.04.15-.09l.02-.05-.54-.22-.07.18Z"
      fill="#000"
    />
    <path
      d="M48.3 37.22a.52.52 0 0 0-.44-.18c-.15.02-.2.14-.1.26.09.12.29.2.44.18.15-.02.2-.13.1-.26Z"
      fill="#2D3534"
    />
    <path d="M48.3 37.22a.52.52 0 0 0-.44-.18l.45.18Z" fill="#414C4A" />
    <path d="M47.75 37.3c.1.12.3.2.45.19.15-.03.2-.14.1-.26" fill="#232B2A" />
    <path
      d="M48.27 37.23a.45.45 0 0 0-.39-.15c-.12.01-.17.12-.08.22.08.1.25.17.38.15.13-.01.17-.12.09-.22Z"
      fill="#000"
    />
    <path
      d="M48.25 37.24a.44.44 0 0 0-.36-.15c-.12.02-.16.11-.09.22.08.09.24.16.36.14.13-.02.17-.11.1-.21Z"
      fill="#2B3332"
    />
    <path d="M47.8 37.3c.08.1.24.17.36.15.13-.02.17-.12.1-.21" fill="#232B2A" />
    <path
      d="m48.5 36.85-.52-.2-.17.41c-.02.05 0 .1.03.14.08.1.24.17.37.15.06-.01.1-.03.12-.07l.17-.43Z"
      fill="#A4BCBB"
    />
    <path
      d="M47.82 37.11v.01l-.01.02c0 .03.02.04.03.06.08.1.25.17.37.15.06-.01.1-.03.12-.07l.17-.43-.5-.2-.18.46Z"
      fill="#74918E"
    />
    <path
      d="m47.84 37.16-.01.01.01.03c.08.1.24.17.37.15.06-.01.1-.03.12-.07l.17-.43-.47-.19-.2.5Z"
      fill="#526D6A"
    />
    <path
      d="m48.02 37.29-.01.02v.01c.06.03.14.04.2.03.06-.01.1-.03.12-.07l.17-.43-.26-.1-.22.54Z"
      fill="#3C5652"
    />
    <path
      d="M48.47 36.7a.43.43 0 0 0-.37-.14c-.12.01-.16.1-.08.21.06.09.2.15.3.15h.07c.12-.02.16-.12.08-.21Z"
      fill="#BCCECC"
    />
    <path
      d="M48.02 36.77c.06.08.2.15.3.15h.07c.12-.02.16-.12.08-.21"
      fill="#A4BCBB"
    />
    <path
      d="M51.4 39.45a1.3 1.3 0 1 1-2.42-.97 1.3 1.3 0 0 1 2.42.97Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M50.81 38.98a.62.62 0 1 1-1.14-.47c.13-.31.57-.66.88-.53.32.13.4.68.26 1Z"
      fill="#FFA300"
    />
    <path
      d="M50.45 38c-.1-.03-.17-.03-.3.03-.17.05-.4.31-.48.48a.62.62 0 0 0 .66.85.61.61 0 0 0 .38-.36c.13-.31.06-.87-.26-1Z"
      fill="#FFB600"
    />
    <path
      d="M50.15 38.03c-.17.05-.4.31-.48.48a.62.62 0 0 0 .66.85"
      fill="#FFC200"
    />
    <path
      d="M50.87 38.56c-.02-.26-.12-.5-.32-.58-.2-.08-.44.03-.63.2 0 .05.03.1.08.16.14.2.46.32.7.29a.3.3 0 0 0 .17-.07Z"
      fill="#FFA300"
    />
    <path
      d="m50.84 38.31-.73-.3-.02.06v.02c-.02.05 0 .11.04.18.11.14.35.23.52.21.09-.01.14-.05.16-.1l.01-.01.02-.06Z"
      fill="#232B2A"
    />
    <path
      d="M50.13 38.27c.11.14.35.23.52.21.09-.01.14-.05.16-.1l.01-.01.03-.06-.63-.25-.09.21Z"
      fill="#000"
    />
    <path
      d="M50.8 38.12a.65.65 0 0 0-.52-.2c-.17.02-.23.16-.12.3.1.13.34.22.52.2.17-.02.23-.16.12-.3Z"
      fill="#2D3534"
    />
    <path d="M50.8 38.12a.65.65 0 0 0-.52-.2l.52.2Z" fill="#C7D8D5" />
    <path
      d="M50.16 38.21c.1.14.34.23.51.21.18-.02.24-.16.13-.3"
      fill="#232B2A"
    />
    <path
      d="M50.75 38.13a.53.53 0 0 0-.44-.18c-.15.02-.2.14-.1.25.09.13.29.2.44.18.15-.02.19-.13.1-.25Z"
      fill="#90AFAD"
    />
    <path
      d="M50.73 38.14a.5.5 0 0 0-.42-.16c-.14.01-.18.12-.1.23.1.12.28.2.42.17.14-.02.18-.13.1-.24Z"
      fill="#7A9E9A"
    />
    <path
      d="M50.22 38.21c.09.12.27.2.41.17.14-.02.19-.13.1-.24"
      fill="#6A918B"
    />
    <path
      d="m50.81 38.24-.63-.26-.02.06v-.02.03c-.02.04 0 .1.04.15.1.13.3.21.45.18.07 0 .12-.04.14-.08v-.01l.02-.05Z"
      fill="#232B2A"
    />
    <path
      d="M50.2 38.2c.1.13.3.21.45.18.07 0 .12-.04.14-.08v-.01l.02-.05-.53-.22-.08.18Z"
      fill="#000"
    />
    <path
      d="M50.77 38.08a.53.53 0 0 0-.44-.18c-.16.02-.2.14-.1.26.09.12.29.2.44.18.15-.02.2-.14.1-.26Z"
      fill="#2D3534"
    />
    <path d="M50.77 38.08a.53.53 0 0 0-.44-.18l.44.18Z" fill="#414C4A" />
    <path d="M50.22 38.16c.1.12.3.2.45.18.15-.02.2-.14.1-.26" fill="#232B2A" />
    <path
      d="M50.73 38.08a.5.5 0 0 0-.38-.15c-.13.02-.17.12-.09.22.08.1.25.17.38.15.13-.01.17-.11.1-.22Z"
      fill="#000"
    />
    <path
      d="M50.72 38.1a.44.44 0 0 0-.36-.15c-.13.02-.16.11-.09.21.08.1.24.16.36.15.12-.02.16-.12.09-.21Z"
      fill="#2B3332"
    />
    <path
      d="M50.27 38.16c.08.1.24.16.36.15.12-.02.16-.12.09-.21"
      fill="#232B2A"
    />
    <path
      d="m50.97 37.71-.53-.21-.17.42c-.01.04 0 .09.04.14.07.1.24.16.37.15.06-.01.1-.04.11-.07l.18-.43Z"
      fill="#A4BCBB"
    />
    <path
      d="M50.28 37.97V38l.02.06c.08.1.25.16.38.15.06-.01.1-.04.11-.07l.18-.43-.5-.2-.19.46Z"
      fill="#74918E"
    />
    <path
      d="M50.3 38.01v.05c.08.1.25.16.38.15.06-.01.1-.04.11-.07l.18-.43-.47-.19-.2.5Z"
      fill="#526D6A"
    />
    <path
      d="M50.48 38.14v.04c.06.03.13.04.2.03.06 0 .1-.04.11-.07l.18-.43-.27-.1-.22.53Z"
      fill="#3C5652"
    />
    <path
      d="M50.94 37.56a.45.45 0 0 0-.37-.15c-.13.02-.17.12-.09.22.07.08.2.15.32.15h.05c.13-.02.17-.12.09-.22Z"
      fill="#BCCECC"
    />
    <path
      d="M50.48 37.63c.07.08.2.15.32.15h.05c.13-.02.17-.12.09-.22"
      fill="#A4BCBB"
    />
    <path
      d="M54.46 39.36a1.3 1.3 0 1 1-2.42-.98 1.3 1.3 0 0 1 2.42.98Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M53.87 38.89a.61.61 0 0 1-.8.33.61.61 0 0 1-.34-.8c.13-.31.57-.66.88-.53.32.13.4.68.26 1Z"
      fill="#FFA300"
    />
    <path
      d="M53.51 37.91c-.1-.04-.16-.04-.3.02-.17.05-.4.31-.48.5a.61.61 0 0 0 .66.83.6.6 0 0 0 .38-.35c.13-.32.06-.87-.26-1Z"
      fill="#FFB600"
    />
    <path
      d="M53.2 37.93c-.16.05-.4.31-.47.5a.61.61 0 0 0 .66.83"
      fill="#FFC200"
    />
    <path
      d="M53.93 38.46c-.02-.25-.12-.5-.32-.57-.2-.08-.44.02-.63.19.01.05.03.11.08.17.15.19.46.31.7.28a.3.3 0 0 0 .17-.07Z"
      fill="#FFA300"
    />
    <path
      d="m53.9 38.21-.73-.3-.02.07v-.01.02c-.02.05 0 .12.05.19.1.13.34.23.51.2a.2.2 0 0 0 .17-.1l.02-.07Z"
      fill="#232B2A"
    />
    <path
      d="M53.2 38.18c.1.13.34.23.51.2a.2.2 0 0 0 .17-.1l.02-.07-.62-.25-.08.22Z"
      fill="#000"
    />
    <path
      d="M53.85 38.03a.6.6 0 0 0-.51-.2c-.18.01-.23.14-.12.3.1.13.34.22.51.2.18-.03.23-.16.12-.3Z"
      fill="#2D3534"
    />
    <path d="M53.85 38.03a.6.6 0 0 0-.51-.2l.51.2Z" fill="#C7D8D5" />
    <path
      d="M53.22 38.12c.1.14.34.23.51.2.18-.02.23-.15.12-.29"
      fill="#232B2A"
    />
    <path
      d="M53.8 38.03a.52.52 0 0 0-.43-.18c-.15.03-.2.14-.1.26.09.12.29.2.44.18.14-.02.2-.14.1-.26Z"
      fill="#90AFAD"
    />
    <path
      d="M53.79 38.05a.51.51 0 0 0-.42-.17c-.14.02-.18.12-.1.24.1.1.28.19.42.17.15-.03.19-.13.1-.24Z"
      fill="#7A9E9A"
    />
    <path
      d="M53.28 38.12c.08.1.27.19.41.17.14-.03.18-.13.1-.24"
      fill="#6A918B"
    />
    <path
      d="m53.88 38.14-.64-.25-.02.05c-.02.06 0 .11.04.17.1.12.3.2.45.18.07 0 .12-.04.14-.08l.01-.02.02-.05Z"
      fill="#232B2A"
    />
    <path
      d="M53.26 38.1c.1.13.3.21.45.2.07-.02.12-.05.14-.1h.01l.02-.06-.54-.22-.08.19Z"
      fill="#000"
    />
    <path
      d="M53.84 37.98a.55.55 0 0 0-.45-.18c-.16.02-.2.14-.1.26.08.12.29.2.44.18.15-.02.2-.13.1-.26Z"
      fill="#2D3534"
    />
    <path d="M53.84 37.98a.55.55 0 0 0-.45-.18l.45.18Z" fill="#414C4A" />
    <path d="M53.28 38.06c.1.12.3.2.45.18.15-.02.2-.13.1-.26" fill="#232B2A" />
    <path
      d="M53.8 37.99a.45.45 0 0 0-.39-.15c-.13.01-.17.11-.09.21.08.1.25.18.38.16.14-.02.17-.11.1-.22Z"
      fill="#000"
    />
    <path
      d="M53.78 38a.46.46 0 0 0-.36-.15c-.13.02-.16.11-.09.21.08.1.24.17.36.15.12-.02.16-.11.09-.21Z"
      fill="#2B3332"
    />
    <path
      d="M53.33 38.06c.08.1.24.17.36.15.12-.02.16-.11.09-.21"
      fill="#232B2A"
    />
    <path
      d="m54.03 37.61-.52-.2-.18.41v.01c-.01.04 0 .09.04.13.07.1.24.17.37.15.06 0 .1-.03.11-.07l.18-.43Z"
      fill="#A4BCBB"
    />
    <path
      d="M53.34 37.87v.03l.03.06c.07.1.24.17.37.15.06 0 .1-.03.11-.07l.18-.43-.5-.2-.19.46Z"
      fill="#74918E"
    />
    <path
      d="M53.36 37.92v.04c.08.1.25.17.38.15.06 0 .1-.03.11-.07l.18-.43-.47-.19-.2.5Z"
      fill="#526D6A"
    />
    <path
      d="M53.54 38.05v.03c.06.03.13.04.2.03.06 0 .1-.03.11-.07l.18-.43-.27-.1-.22.54Z"
      fill="#3C5652"
    />
    <path
      d="M54 37.47a.44.44 0 0 0-.37-.15c-.13.01-.17.1-.09.2.07.1.2.16.31.16h.06c.13-.02.17-.11.09-.21Z"
      fill="#BCCECC"
    />
    <path
      d="M53.54 37.53c.07.08.2.15.31.15h.06c.13-.02.17-.11.09-.21"
      fill="#A4BCBB"
    />
    <path
      d="M57.3 38.5a1.3 1.3 0 1 1-2.42-.97 1.3 1.3 0 0 1 2.42.97Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M56.72 38.02a.61.61 0 0 1-.8.34.61.61 0 0 1-.35-.8c.13-.31.57-.66.88-.53.32.13.4.68.27 1Z"
      fill="#FFA300"
    />
    <path
      d="M56.35 37.05c-.1-.04-.16-.03-.3.02-.17.05-.4.32-.48.5-.13.31.03.67.34.8.1.04.22.05.32.04a.61.61 0 0 0 .38-.36c.13-.31.06-.87-.26-1Z"
      fill="#FFB600"
    />
    <path
      d="M56.05 37.07c-.17.06-.4.32-.48.5-.13.31.03.67.34.8.1.04.22.05.32.04"
      fill="#FFC200"
    />
    <path
      d="M56.77 37.6c-.02-.25-.12-.5-.32-.57-.2-.08-.44.03-.62.19 0 .05.02.12.07.17.15.19.46.32.7.28.07 0 .13-.03.17-.07Z"
      fill="#FFA300"
    />
    <path
      d="m56.75 37.36-.74-.3-.02.06v.01c-.02.05 0 .12.05.19.1.13.34.23.51.2.09 0 .14-.04.17-.1l.03-.06Z"
      fill="#232B2A"
    />
    <path
      d="M56.04 37.32c.1.13.34.23.51.2.09 0 .14-.04.17-.1l.03-.06-.63-.26-.08.22Z"
      fill="#000"
    />
    <path
      d="M56.7 37.17a.64.64 0 0 0-.52-.21c-.18.03-.23.16-.12.3.1.14.34.23.52.2.17-.02.23-.15.12-.29Z"
      fill="#2D3534"
    />
    <path d="M56.7 37.17a.64.64 0 0 0-.52-.21l.52.21Z" fill="#C7D8D5" />
    <path
      d="M56.06 37.26c.1.14.34.23.52.2.17-.02.23-.15.12-.3"
      fill="#232B2A"
    />
    <path
      d="M56.65 37.18a.52.52 0 0 0-.44-.18c-.15.02-.2.14-.1.25.09.12.29.2.44.18.15-.02.2-.13.1-.25Z"
      fill="#90AFAD"
    />
    <path
      d="M56.63 37.19a.5.5 0 0 0-.42-.17c-.14.02-.18.13-.1.24a.5.5 0 0 0 .42.17c.14-.02.19-.13.1-.24Z"
      fill="#7A9E9A"
    />
    <path
      d="M56.12 37.26a.5.5 0 0 0 .41.17c.14-.02.19-.13.1-.24"
      fill="#6A918B"
    />
    <path
      d="m56.72 37.29-.64-.26-.02.05v.01c-.01.05 0 .1.04.16.1.12.3.2.45.19.07-.02.12-.05.14-.1l.03-.05Z"
      fill="#232B2A"
    />
    <path
      d="M56.1 37.25c.1.12.3.2.45.18.07 0 .12-.04.14-.08v-.02l.03-.04-.54-.22-.08.18Z"
      fill="#000"
    />
    <path
      d="M56.67 37.13a.5.5 0 0 0-.45-.18c-.14.02-.2.13-.1.25.1.13.3.2.45.18.15-.02.2-.13.1-.25Z"
      fill="#2D3534"
    />
    <path d="M56.67 37.13a.5.5 0 0 0-.44-.18l.44.18Z" fill="#414C4A" />
    <path d="M56.12 37.2c.1.13.3.2.45.18.15-.02.2-.13.1-.25" fill="#232B2A" />
    <path
      d="M56.63 37.13a.45.45 0 0 0-.38-.15c-.13.02-.17.12-.09.22.08.1.26.17.39.15.12-.01.16-.11.08-.22Z"
      fill="#000"
    />
    <path
      d="M56.62 37.14a.44.44 0 0 0-.36-.14c-.13.02-.16.1-.09.2.08.1.24.17.36.15.13-.02.16-.1.09-.2Z"
      fill="#2B3332"
    />
    <path d="M56.17 37.2c.08.1.24.17.36.15.13-.02.16-.1.09-.2" fill="#232B2A" />
    <path
      d="m56.87 36.76-.53-.22-.17.42v.01c-.01.04 0 .09.04.13.08.1.24.17.37.15.06 0 .1-.03.12-.07l.17-.42Z"
      fill="#A4BCBB"
    />
    <path
      d="M56.18 37.01v.04c0 .02.01.03.03.05.08.1.24.17.37.15.06 0 .1-.03.12-.07l.17-.42-.5-.2-.19.45Z"
      fill="#74918E"
    />
    <path
      d="M56.2 37.06v.04c.09.1.25.17.38.15.06 0 .1-.03.12-.07l.17-.42-.47-.2-.2.5Z"
      fill="#526D6A"
    />
    <path
      d="M56.38 37.19v.03a.4.4 0 0 0 .2.03c.06 0 .1-.03.12-.07l.17-.42-.27-.11-.22.54Z"
      fill="#3C5652"
    />
    <path
      d="M56.84 36.61a.41.41 0 0 0-.37-.15c-.13.01-.17.11-.09.21.07.09.2.15.32.15h.05c.13-.02.17-.11.09-.2Z"
      fill="#BCCECC"
    />
    <path
      d="M56.38 36.67c.07.09.2.15.32.15h.05c.13-.02.17-.11.09-.2"
      fill="#A4BCBB"
    />
    <path
      d="M59.58 37.4a1.3 1.3 0 1 1-2.52-.64 1.3 1.3 0 0 1 2.52.64Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M58.93 37.01a.61.61 0 0 1-.74.45.62.62 0 0 1-.45-.75c.09-.33.47-.73.8-.65.33.08.48.62.4.95Z"
      fill="#FFA300"
    />
    <path
      d="M58.44 36.1c-.1-.03-.17-.02-.3.06-.16.07-.36.37-.4.55a.62.62 0 0 0 .76.74.6.6 0 0 0 .34-.4c.08-.33-.07-.87-.4-.96Z"
      fill="#FFB600"
    />
    <path
      d="M58.14 36.16c-.16.07-.36.37-.4.55a.62.62 0 0 0 .76.74"
      fill="#FFC200"
    />
    <path
      d="M58.93 36.58c-.05-.24-.19-.47-.39-.52-.2-.05-.43.08-.6.27.02.06.05.1.1.16.17.17.5.25.73.19a.31.31 0 0 0 .16-.1Z"
      fill="#FFA300"
    />
    <path
      d="m58.88 36.34-.77-.2-.02.07.01-.01v.02c-.02.05 0 .12.06.18.13.12.37.19.55.14.08-.03.13-.07.15-.12v-.02l.02-.06Z"
      fill="#232B2A"
    />
    <path
      d="M58.16 36.4c.13.12.37.19.55.14.08-.03.13-.07.15-.13v-.01l.02-.06-.66-.17-.06.23Z"
      fill="#000"
    />
    <path
      d="M58.8 36.17a.61.61 0 0 0-.54-.14c-.17.05-.2.18-.08.31.13.12.37.18.54.14.17-.05.21-.2.08-.31Z"
      fill="#2D3534"
    />
    <path d="M58.8 36.17a.61.61 0 0 0-.54-.14l.54.14Z" fill="#C7D8D5" />
    <path
      d="M58.18 36.34c.13.12.37.18.54.14.17-.05.21-.2.08-.31"
      fill="#232B2A"
    />
    <path
      d="M58.76 36.18a.56.56 0 0 0-.46-.12c-.15.04-.18.16-.07.27.1.1.31.15.46.11.14-.04.18-.16.07-.26Z"
      fill="#90AFAD"
    />
    <path
      d="M58.74 36.2a.48.48 0 0 0-.44-.11c-.13.03-.16.14-.06.25.1.09.3.14.43.1.14-.04.17-.15.07-.25Z"
      fill="#7A9E9A"
    />
    <path
      d="M58.24 36.34c.1.09.3.14.43.1.14-.04.17-.15.07-.25"
      fill="#6A918B"
    />
    <path
      d="m58.84 36.28-.67-.17-.01.06v-.02.03c-.01.04.01.1.06.15.11.1.32.16.47.12a.2.2 0 0 0 .13-.1v-.02l.02-.05Z"
      fill="#232B2A"
    />
    <path
      d="M58.22 36.33c.11.1.32.16.47.12a.2.2 0 0 0 .13-.1v-.02l.02-.05-.57-.15-.05.2Z"
      fill="#000"
    />
    <path
      d="M58.77 36.13a.52.52 0 0 0-.47-.13c-.14.05-.18.17-.06.27.1.1.32.17.46.13.15-.05.18-.17.07-.27Z"
      fill="#2D3534"
    />
    <path d="M58.77 36.13a.52.52 0 0 0-.47-.13l.47.13Z" fill="#414C4A" />
    <path
      d="M58.24 36.27c.1.1.32.17.46.13.15-.05.18-.17.07-.28"
      fill="#232B2A"
    />
    <path
      d="M58.73 36.13a.44.44 0 0 0-.4-.1c-.12.04-.15.14-.06.23.1.1.28.14.4.1.13-.03.16-.13.06-.23Z"
      fill="#000"
    />
    <path
      d="M58.72 36.15a.43.43 0 0 0-.38-.1c-.12.03-.14.13-.06.22.1.09.26.13.38.1.12-.04.15-.14.06-.22Z"
      fill="#2B3332"
    />
    <path
      d="M58.28 36.27c.1.09.26.13.38.1.12-.04.15-.14.06-.22"
      fill="#232B2A"
    />
    <path
      d="m58.91 35.73-.54-.14-.11.44v.01c-.01.04 0 .08.05.13.09.08.26.13.38.1.06-.03.1-.05.1-.1l.12-.44Z"
      fill="#A4BCBB"
    />
    <path
      d="M58.27 36.08v.03c0 .02.02.04.04.06.09.08.26.13.39.1.05-.03.09-.05.1-.1l.11-.44-.52-.13-.12.48Z"
      fill="#74918E"
    />
    <path
      d="M58.3 36.12v.01l-.01.02.02.02c.09.08.26.13.38.1.06-.03.1-.05.1-.1l.12-.44-.48-.12-.14.51Z"
      fill="#526D6A"
    />
    <path
      d="M58.5 36.22v.01l-.01.01v.02c.07.02.14.02.2 0s.1-.04.1-.08l.12-.45-.27-.07-.15.56Z"
      fill="#3C5652"
    />
    <path
      d="M58.86 35.59a.43.43 0 0 0-.38-.1c-.12.03-.15.14-.06.22.08.08.22.12.33.11h.06c.12-.04.15-.14.05-.23Z"
      fill="#BCCECC"
    />
    <path
      d="M58.42 35.71c.08.08.22.12.33.11h.06c.12-.05.15-.14.05-.23"
      fill="#A4BCBB"
    />
    <path
      d="M45.17 34.52s.22.23.65.58a10.56 10.56 0 0 0 4.97 2.18c.58.08 1.18.1 1.8.09.6-.05 1.23-.12 1.83-.27a13.71 13.71 0 0 0 3.42-1.3c.27-.13.52-.3.76-.43.25-.15.49-.29.71-.44l.66-.44.59-.44c.38-.28.72-.56 1.02-.8l.76-.64.66-.58-.6.64c-.2.2-.43.44-.72.7-.28.26-.6.57-.97.86l-.58.48-.65.47c-.22.17-.45.32-.7.48a14.7 14.7 0 0 1-2.43 1.26 11.51 11.51 0 0 1-3.75.84c-.64 0-1.27-.02-1.86-.12a8.6 8.6 0 0 1-3.1-1.1 9.46 9.46 0 0 1-2.47-2.02Z"
      fill="#547277"
    />
    <path
      d="M42.88 62.14a2.04 2.04 0 1 0 0-4.09 2.04 2.04 0 0 0 0 4.09Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M43.86 60.11a.97.97 0 1 1-1.8-.73c.2-.49.9-1.03 1.39-.83.5.2.6 1.07.4 1.56Z"
      fill="#FFA300"
    />
    <path
      d="M43.29 58.59c-.16-.07-.26-.06-.48.03-.26.08-.63.49-.74.77a.97.97 0 0 0 1.02 1.32c.27-.09.5-.28.6-.56.2-.5.1-1.36-.4-1.56Z"
      fill="#FFB600"
    />
    <path
      d="M42.81 58.62c-.26.08-.63.49-.74.77a.97.97 0 0 0 1.02 1.32"
      fill="#FFC200"
    />
    <path
      d="M43.94 59.45c-.02-.39-.18-.77-.5-.9-.3-.12-.69.04-.98.3.01.08.04.18.12.26.23.3.73.5 1.1.45a.5.5 0 0 0 .26-.1Z"
      fill="#FFA300"
    />
    <path
      d="m43.9 59.07-1.14-.47-.04.1v-.02.04c-.03.07-.01.18.07.29a1 1 0 0 0 .81.32c.13-.02.22-.08.26-.15v-.02l.04-.1Z"
      fill="#232B2A"
    />
    <path
      d="M42.8 59a1 1 0 0 0 .8.33c.13-.02.22-.08.26-.15v-.02l.04-.1-.97-.39-.14.33Z"
      fill="#000"
    />
    <path
      d="M43.83 58.77a.96.96 0 0 0-.81-.32c-.28.03-.37.25-.2.46a1 1 0 0 0 .82.33c.27-.03.36-.25.19-.47Z"
      fill="#2D3534"
    />
    <path d="M43.83 58.77a.96.96 0 0 0-.81-.33l.8.33Z" fill="#C7D8D5" />
    <path
      d="M42.83 58.91a1 1 0 0 0 .8.33c.28-.03.37-.25.2-.47"
      fill="#232B2A"
    />
    <path
      d="M43.76 58.78a.83.83 0 0 0-.7-.28c-.23.03-.3.22-.16.4.15.2.46.32.7.28.23-.03.3-.21.16-.4Z"
      fill="#90AFAD"
    />
    <path
      d="M43.72 58.8a.77.77 0 0 0-.65-.26c-.22.03-.29.2-.15.38.14.18.43.3.65.26.22-.03.3-.2.15-.38Z"
      fill="#7A9E9A"
    />
    <path
      d="M42.92 58.92c.14.18.43.3.65.26.22-.03.3-.2.15-.38"
      fill="#6A918B"
    />
    <path
      d="m43.86 58.96-1-.4-.03.08v-.01.01c-.02.08 0 .17.07.26a.8.8 0 0 0 .7.28c.11 0 .2-.06.22-.13l.01-.02.03-.07Z"
      fill="#232B2A"
    />
    <path
      d="M42.9 58.9a.8.8 0 0 0 .7.28c.11 0 .2-.06.22-.13v-.02l.04-.07-.85-.35-.12.29Z"
      fill="#000"
    />
    <path
      d="M43.8 58.7a.82.82 0 0 0-.71-.28c-.24.04-.31.22-.17.4.15.2.47.33.7.3.25-.04.32-.22.17-.41Z"
      fill="#2D3534"
    />
    <path d="M43.8 58.7a.81.81 0 0 0-.71-.28l.7.29Z" fill="#414C4A" />
    <path
      d="M42.92 58.83c.15.19.47.32.7.28.25-.03.32-.21.17-.4"
      fill="#232B2A"
    />
    <path
      d="M43.73 58.71a.7.7 0 0 0-.6-.24c-.2.03-.27.19-.14.35.13.16.4.27.6.24.2-.02.27-.19.14-.35Z"
      fill="#000"
    />
    <path
      d="M43.7 58.73a.68.68 0 0 0-.56-.23c-.2.03-.25.17-.14.33a.7.7 0 0 0 .57.23c.2-.04.25-.18.13-.33Z"
      fill="#2B3332"
    />
    <path d="M43 58.83a.7.7 0 0 0 .57.23c.2-.04.25-.18.13-.33" fill="#232B2A" />
    <path
      d="m44.1 58.12-.82-.33-.27.66v.01c-.02.06 0 .13.05.21.12.16.38.27.58.23.1-.01.16-.05.19-.1l.27-.68Z"
      fill="#A4BCBB"
    />
    <path
      d="M43.02 58.53v.01l-.01.04.05.09c.12.16.38.27.58.23.1-.01.16-.05.19-.1l.27-.68-.79-.32-.29.73Z"
      fill="#74918E"
    />
    <path
      d="M43.05 58.6v.03l.01.04c.12.16.38.27.58.23.1-.01.16-.05.19-.1l.27-.68-.73-.3-.32.78Z"
      fill="#526D6A"
    />
    <path
      d="M43.34 58.8v.02l-.01.01-.01.02c.1.05.23.07.32.06.1-.02.16-.06.19-.12l.27-.67-.42-.17-.34.86Z"
      fill="#3C5652"
    />
    <path
      d="M44.05 57.9a.68.68 0 0 0-.58-.24c-.2.02-.26.17-.13.34.1.12.3.22.49.23h.09c.2-.03.26-.18.13-.34Z"
      fill="#BCCECC"
    />
    <path
      d="M43.34 58c.1.12.3.22.49.23h.09c.2-.03.26-.18.13-.34"
      fill="#A4BCBB"
    />
    <path
      d="M48.64 62.2a2.04 2.04 0 1 1-3.79-1.52 2.04 2.04 0 0 1 3.8 1.52Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M47.72 61.45a.97.97 0 1 1-1.78-.72c.2-.5.88-1.04 1.37-.84.5.2.61 1.07.41 1.56Z"
      fill="#FFA300"
    />
    <path
      d="M47.16 59.93c-.17-.06-.26-.05-.48.03-.26.09-.64.5-.74.77a.97.97 0 0 0 1.02 1.32.9.9 0 0 0 .6-.56c.2-.5.1-1.36-.4-1.56Z"
      fill="#FFB600"
    />
    <path
      d="M46.68 59.96c-.26.09-.64.5-.74.77a.97.97 0 0 0 1.02 1.32"
      fill="#FFC200"
    />
    <path
      d="M47.81 60.8c-.02-.4-.18-.78-.5-.9-.3-.13-.69.03-.98.3 0 .08.04.17.12.26.23.3.72.5 1.1.45.1-.02.2-.06.26-.12Z"
      fill="#FFA300"
    />
    <path
      d="m47.77 60.4-1.14-.46-.04.1v-.02.03c-.03.09-.01.19.07.3.17.2.54.36.8.32.14-.02.23-.07.27-.15v-.02l.04-.1Z"
      fill="#232B2A"
    />
    <path
      d="M46.66 60.35c.17.21.54.36.8.33.14-.03.23-.08.27-.16v-.02l.05-.1-.98-.39-.14.34Z"
      fill="#000"
    />
    <path
      d="M47.7 60.11a1.02 1.02 0 0 0-.81-.33c-.28.04-.36.26-.2.47.18.22.54.37.82.33.27-.03.36-.25.19-.47Z"
      fill="#2D3534"
    />
    <path d="M47.7 60.11a1.02 1.02 0 0 0-.81-.33l.8.33Z" fill="#C7D8D5" />
    <path
      d="M46.7 60.25c.17.22.53.37.8.33.28-.03.37-.25.2-.47"
      fill="#232B2A"
    />
    <path
      d="M47.62 60.12a.84.84 0 0 0-.68-.28c-.24.04-.32.21-.17.4.15.2.46.32.7.28.23-.03.3-.2.15-.4Z"
      fill="#90AFAD"
    />
    <path
      d="M47.6 60.15a.78.78 0 0 0-.66-.27c-.22.03-.29.2-.15.38.14.18.43.3.65.26.22-.03.29-.2.15-.37Z"
      fill="#7A9E9A"
    />
    <path
      d="M46.79 60.26c.14.18.43.3.65.26.22-.03.29-.2.15-.37"
      fill="#6A918B"
    />
    <path
      d="m47.73 60.3-1-.4-.03.08v-.02.03c-.03.07 0 .16.07.25.14.2.46.32.7.28.11 0 .19-.06.22-.13v-.01l.04-.08Z"
      fill="#232B2A"
    />
    <path
      d="M46.77 60.24c.14.2.46.32.7.28.11-.01.19-.06.22-.13v-.02l.04-.07-.85-.34-.11.28Z"
      fill="#000"
    />
    <path
      d="M47.66 60.05a.83.83 0 0 0-.7-.29c-.24.04-.31.22-.16.4.15.2.46.32.7.29.24-.03.31-.21.16-.4Z"
      fill="#2D3534"
    />
    <path d="M47.66 60.05a.83.83 0 0 0-.7-.29l.7.29Z" fill="#414C4A" />
    <path
      d="M46.8 60.17c.15.19.46.31.7.28.24-.03.31-.21.16-.4"
      fill="#232B2A"
    />
    <path
      d="M47.6 60.05a.77.77 0 0 0-.6-.24c-.2.03-.27.18-.14.34.12.17.4.28.6.24.2-.02.27-.18.14-.34Z"
      fill="#000"
    />
    <path
      d="M47.57 60.07a.69.69 0 0 0-.56-.23c-.2.03-.26.18-.14.33.12.15.38.26.57.23.19-.03.25-.18.13-.33Z"
      fill="#2B3332"
    />
    <path
      d="M46.87 60.17c.12.15.38.26.57.23.19-.03.25-.18.13-.33"
      fill="#232B2A"
    />
    <path
      d="m47.97 59.47-.83-.34-.26.66v.01c-.02.06 0 .14.05.21a.7.7 0 0 0 .58.24c.1-.02.16-.06.18-.11l.28-.67Z"
      fill="#A4BCBB"
    />
    <path
      d="M46.89 59.87v.01l-.01.04.05.1c.12.15.38.25.58.23.1-.01.16-.06.18-.11l.27-.67-.78-.32-.3.72Z"
      fill="#74918E"
    />
    <path
      d="m46.92 59.94-.01.03.02.04a.7.7 0 0 0 .58.24c.1-.01.16-.06.18-.11l.28-.67-.74-.3-.31.77Z"
      fill="#526D6A"
    />
    <path
      d="M47.2 60.15v.03l-.01.02c.1.04.22.06.32.05.1-.01.16-.06.18-.11l.27-.67-.41-.17-.35.85Z"
      fill="#3C5652"
    />
    <path
      d="M47.92 59.23a.7.7 0 0 0-.58-.23c-.2.03-.26.18-.14.34.1.12.31.23.5.24h.08c.2-.03.27-.19.14-.35Z"
      fill="#BCCECC"
    />
    <path
      d="M47.2 59.34c.1.12.31.23.5.24h.08c.2-.03.27-.19.14-.35"
      fill="#A4BCBB"
    />
    <path
      d="M53.45 62.05a2.04 2.04 0 1 1-3.8-1.53 2.04 2.04 0 0 1 3.8 1.53Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M52.52 61.31c-.2.5-.76.73-1.25.53a.96.96 0 0 1-.54-1.26c.2-.5.89-1.03 1.39-.83.49.2.6 1.06.4 1.56Z"
      fill="#FFA300"
    />
    <path
      d="M51.96 59.78c-.16-.07-.26-.06-.48.03-.26.08-.63.5-.75.77-.2.5.04 1.06.54 1.26.16.06.33.09.5.06a.96.96 0 0 0 .6-.55c.2-.5.08-1.37-.41-1.57Z"
      fill="#FFB600"
    />
    <path
      d="M51.48 59.8c-.26.1-.64.5-.75.78-.2.5.04 1.06.54 1.26.16.06.33.09.5.06"
      fill="#FFC200"
    />
    <path
      d="M52.61 60.65c-.02-.4-.19-.78-.5-.9-.3-.13-.69.03-.98.3.01.08.05.17.12.26.23.3.72.5 1.1.44.11 0 .2-.05.26-.1Z"
      fill="#FFA300"
    />
    <path
      d="m52.57 60.26-1.14-.47-.04.1v-.01.02c-.03.08-.01.2.07.3.17.21.54.36.81.32a.3.3 0 0 0 .26-.16v-.01l.04-.1Z"
      fill="#232B2A"
    />
    <path
      d="M51.46 60.2c.17.21.54.36.8.32.14-.01.23-.08.27-.16v-.01l.04-.1-.97-.39-.14.34Z"
      fill="#000"
    />
    <path
      d="M52.5 59.97a.94.94 0 0 0-.81-.33c-.28.04-.36.24-.2.47.18.22.54.36.81.33.28-.05.37-.25.2-.47Z"
      fill="#2D3534"
    />
    <path d="M52.5 59.97a.94.94 0 0 0-.81-.33l.8.33Z" fill="#C7D8D5" />
    <path
      d="M51.5 60.11c.17.22.53.36.8.33.28-.05.37-.25.2-.47"
      fill="#232B2A"
    />
    <path
      d="M52.42 59.97a.81.81 0 0 0-.69-.28c-.23.04-.3.22-.16.4.15.2.46.32.7.29.23-.04.3-.22.15-.4Z"
      fill="#90AFAD"
    />
    <path
      d="M52.4 60a.8.8 0 0 0-.66-.27c-.22.04-.29.2-.15.38.14.17.43.3.65.26.22-.03.29-.2.15-.37Z"
      fill="#7A9E9A"
    />
    <path
      d="M51.59 60.11c.14.17.43.3.65.26.22-.03.29-.2.15-.37"
      fill="#6A918B"
    />
    <path
      d="m52.53 60.15-1-.4-.03.08v-.02.03c-.03.08 0 .17.06.25.15.2.47.32.71.3.1-.02.19-.08.22-.14l.01-.03.03-.07Z"
      fill="#232B2A"
    />
    <path
      d="M51.56 60.1c.15.19.47.31.7.28.12-.01.2-.07.23-.14l.01-.02.03-.07-.85-.35-.12.3Z"
      fill="#000"
    />
    <path
      d="M52.47 59.9a.86.86 0 0 0-.71-.29c-.24.03-.31.22-.17.4.15.2.47.33.71.3.24-.04.31-.22.17-.41Z"
      fill="#2D3534"
    />
    <path d="M52.47 59.9a.86.86 0 0 0-.71-.29l.7.29Z" fill="#414C4A" />
    <path
      d="M51.6 60.02a.8.8 0 0 0 .7.28c.24-.03.31-.21.17-.4"
      fill="#232B2A"
    />
    <path
      d="M52.4 59.9a.71.71 0 0 0-.6-.24c-.2.03-.27.18-.14.34.13.17.4.28.6.25.2-.03.27-.18.14-.34Z"
      fill="#000"
    />
    <path
      d="M52.37 59.92a.72.72 0 0 0-.56-.23c-.2.03-.25.18-.13.33.12.15.37.26.56.23.2-.03.25-.18.13-.33Z"
      fill="#2B3332"
    />
    <path
      d="M51.68 60.02c.12.15.37.25.56.22.2-.02.25-.17.13-.32"
      fill="#232B2A"
    />
    <path
      d="m52.77 59.32-.82-.34-.27.67c-.02.07 0 .14.05.21.12.16.38.27.58.24.1-.02.15-.05.18-.11l.28-.67Z"
      fill="#A4BCBB"
    />
    <path
      d="m51.7 59.72-.01.01-.01.04a.4.4 0 0 0 .05.1.7.7 0 0 0 .58.23c.1-.01.15-.05.18-.1l.28-.68-.79-.32-.29.72Z"
      fill="#74918E"
    />
    <path
      d="M51.72 59.8v.01l-.01.01c0 .03.01.03.02.04.12.16.38.27.58.24.1-.02.15-.05.18-.11l.28-.67-.74-.3-.31.78Z"
      fill="#526D6A"
    />
    <path
      d="M52 60v.02l-.01.03c.1.04.22.05.32.05.1-.02.15-.05.18-.11l.28-.67-.42-.17L52 60Z"
      fill="#3C5652"
    />
    <path
      d="M52.72 59.09a.69.69 0 0 0-.58-.24c-.2.03-.26.17-.13.33.1.14.3.24.48.25l.1-.01c.2-.03.25-.18.13-.33Z"
      fill="#BCCECC"
    />
    <path
      d="M52 59.18c.1.14.32.24.5.25l.09-.01c.2-.03.25-.18.13-.33"
      fill="#A4BCBB"
    />
    <path
      d="M57.9 60.71a2.05 2.05 0 1 1-3.8-1.53 2.05 2.05 0 0 1 3.8 1.53Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M56.98 59.96c-.2.5-.76.73-1.26.53a.96.96 0 0 1-.53-1.26c.2-.49.89-1.03 1.38-.83.5.2.61 1.07.41 1.56Z"
      fill="#FFA300"
    />
    <path
      d="M56.41 58.44c-.16-.07-.25-.06-.47.03-.26.08-.64.49-.75.76-.2.5.04 1.06.53 1.26.17.07.34.1.5.07.27-.09.5-.28.6-.56.2-.5.09-1.36-.4-1.56Z"
      fill="#FFB600"
    />
    <path
      d="M55.94 58.47c-.26.08-.64.49-.75.76-.2.5.04 1.06.53 1.26.17.07.34.1.5.07"
      fill="#FFC200"
    />
    <path
      d="M57.07 59.3c-.03-.4-.2-.78-.5-.9-.3-.13-.69.04-.98.3 0 .08.04.18.12.27.23.3.72.5 1.09.44a.4.4 0 0 0 .27-.12Z"
      fill="#FFA300"
    />
    <path
      d="m57.03 58.91-1.15-.46-.03.1v-.02.03c-.04.08-.01.18.07.3a1 1 0 0 0 .81.32c.13-.02.22-.08.26-.16V59l.04-.09Z"
      fill="#232B2A"
    />
    <path
      d="M55.92 58.85a1 1 0 0 0 .81.33c.13-.02.22-.08.26-.16V59l.04-.09-.98-.4-.13.34Z"
      fill="#000"
    />
    <path
      d="M56.96 58.62a1 1 0 0 0-.81-.33c-.28.04-.37.25-.2.47.18.22.54.36.82.33.27-.04.36-.25.19-.47Z"
      fill="#2D3534"
    />
    <path d="M56.96 58.62a1 1 0 0 0-.81-.33l.81.33Z" fill="#C7D8D5" />
    <path
      d="M55.96 58.76c.17.22.53.36.8.33.28-.04.37-.25.2-.47"
      fill="#232B2A"
    />
    <path
      d="M56.88 58.63a.81.81 0 0 0-.7-.28c-.22.03-.3.21-.15.4.15.18.46.3.7.28.22-.03.3-.21.15-.4Z"
      fill="#90AFAD"
    />
    <path
      d="M56.85 58.65a.78.78 0 0 0-.65-.26c-.22.03-.29.2-.15.37.14.18.43.3.65.27.22-.04.29-.2.15-.38Z"
      fill="#7A9E9A"
    />
    <path
      d="M56.05 58.76c.14.18.43.3.65.26.22-.03.29-.2.15-.37"
      fill="#6A918B"
    />
    <path
      d="m56.99 58.8-1-.4-.03.08v.01c-.03.08 0 .17.06.26.15.19.47.32.7.28.12-.01.2-.06.23-.13v-.02l.04-.08Z"
      fill="#232B2A"
    />
    <path
      d="M56.02 58.75c.15.19.47.32.7.28.12-.01.2-.06.23-.13v-.02l.04-.08-.85-.34-.12.29Z"
      fill="#000"
    />
    <path
      d="M56.92 58.55a.79.79 0 0 0-.7-.28c-.24.03-.31.21-.17.4.15.2.47.32.7.28.24-.03.32-.21.17-.4Z"
      fill="#2D3534"
    />
    <path d="M56.92 58.55a.79.79 0 0 0-.7-.28l.7.28Z" fill="#414C4A" />
    <path
      d="M56.05 58.67c.15.2.47.32.7.28.25-.03.32-.21.17-.4"
      fill="#232B2A"
    />
    <path
      d="M56.86 58.56a.7.7 0 0 0-.6-.24c-.2.03-.27.18-.14.34.12.17.4.28.6.24.2-.02.26-.17.14-.34Z"
      fill="#000"
    />
    <path
      d="M56.83 58.58a.7.7 0 0 0-.57-.23c-.19.03-.25.17-.13.32.12.16.38.26.57.23.2-.03.25-.17.13-.32Z"
      fill="#2B3332"
    />
    <path
      d="M56.13 58.67c.12.16.38.26.57.23.2-.03.25-.17.13-.32"
      fill="#232B2A"
    />
    <path
      d="m57.23 57.97-.83-.33-.27.66c-.02.07 0 .14.06.21.12.16.38.27.58.24.1-.01.16-.05.18-.11l.28-.67Z"
      fill="#A4BCBB"
    />
    <path
      d="M56.15 58.38v.01l-.01.04c0 .03.02.05.05.08.12.16.38.27.58.24.09-.01.15-.05.18-.11l.27-.67-.78-.32-.3.73Z"
      fill="#74918E"
    />
    <path
      d="m56.18 58.45-.01.01v.02c0 .02.01.02.02.03.12.16.38.27.58.24.09-.01.15-.05.18-.11l.27-.67-.73-.3-.31.78Z"
      fill="#526D6A"
    />
    <path
      d="M56.46 58.65v.03l-.01.02c.1.04.22.06.32.05.09-.01.15-.05.18-.11l.27-.67-.41-.17-.35.85Z"
      fill="#3C5652"
    />
    <path
      d="M57.18 57.74a.65.65 0 0 0-.58-.23c-.2.02-.26.17-.14.33.1.13.31.23.5.24h.08c.2-.03.26-.19.14-.34Z"
      fill="#BCCECC"
    />
    <path
      d="M56.46 57.84c.1.13.31.23.5.24h.08c.2-.03.26-.19.14-.34"
      fill="#A4BCBB"
    />
    <path
      d="M61.48 58.98a2.04 2.04 0 1 1-3.97-1 2.04 2.04 0 0 1 3.97 1Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M60.46 58.37a.96.96 0 0 1-1.17.7.97.97 0 0 1-.7-1.18c.13-.52.74-1.15 1.26-1.02.51.14.74.98.61 1.5Z"
      fill="#FFA300"
    />
    <path
      d="M59.7 56.93c-.18-.04-.27-.02-.48.1-.25.12-.56.58-.63.86a.97.97 0 0 0 1.2 1.17.95.95 0 0 0 .52-.64c.13-.51-.1-1.36-.62-1.49Z"
      fill="#FFB600"
    />
    <path
      d="M59.22 57.03c-.25.12-.56.58-.63.86a.97.97 0 0 0 1.2 1.17"
      fill="#FFC200"
    />
    <path
      d="M60.46 57.7c-.08-.39-.3-.74-.61-.83-.33-.08-.69.14-.94.44.02.08.07.16.15.24.27.27.79.4 1.15.3a.5.5 0 0 0 .25-.15Z"
      fill="#FFA300"
    />
    <path
      d="m60.37 57.32-1.2-.3-.02.1v-.02.02c-.02.09.01.2.1.29.2.2.59.3.85.21.13-.04.21-.1.24-.19v-.02l.03-.1Z"
      fill="#232B2A"
    />
    <path
      d="M59.26 57.41c.2.2.58.3.84.21.13-.04.21-.1.24-.19v-.02l.03-.1-1.02-.25-.1.35Z"
      fill="#000"
    />
    <path
      d="M60.25 57.05a.95.95 0 0 0-.84-.22c-.27.07-.33.29-.13.49a1 1 0 0 0 .85.21c.27-.07.33-.3.12-.48Z"
      fill="#2D3534"
    />
    <path d="M60.25 57.05a.95.95 0 0 0-.84-.22l.84.22Z" fill="#C7D8D5" />
    <path
      d="M59.28 57.32a1 1 0 0 0 .85.21c.27-.07.33-.3.12-.49"
      fill="#232B2A"
    />
    <path
      d="M60.18 57.06a.88.88 0 0 0-.72-.19c-.23.08-.28.26-.1.43.16.16.49.24.72.18.22-.07.27-.26.1-.42Z"
      fill="#90AFAD"
    />
    <path
      d="M60.15 57.09a.76.76 0 0 0-.68-.17c-.21.05-.26.23-.1.39a.8.8 0 0 0 .68.17c.22-.06.26-.24.1-.4Z"
      fill="#7A9E9A"
    />
    <path
      d="M59.37 57.31a.8.8 0 0 0 .68.17c.22-.06.26-.24.1-.4"
      fill="#6A918B"
    />
    <path
      d="m60.31 57.22-1.04-.26-.02.09v-.02.03c-.02.07.01.15.1.24.17.16.5.25.73.18.11-.02.18-.09.2-.16l.01-.02.02-.08Z"
      fill="#232B2A"
    />
    <path
      d="M59.35 57.3c.17.16.5.25.73.18.11-.02.18-.09.2-.16l.01-.02.02-.08-.89-.23-.07.3Z"
      fill="#000"
    />
    <path
      d="M60.2 56.98a.82.82 0 0 0-.73-.19c-.23.07-.28.26-.1.42.17.17.5.26.73.2.23-.07.28-.26.1-.43Z"
      fill="#2D3534"
    />
    <path d="M60.2 56.98a.82.82 0 0 0-.73-.19l.74.19Z" fill="#414C4A" />
    <path d="M59.37 57.2c.17.18.5.27.73.2.23-.06.28-.25.1-.42" fill="#232B2A" />
    <path
      d="M60.15 57a.69.69 0 0 0-.63-.16c-.2.05-.24.21-.1.35.16.15.44.22.64.16.2-.05.24-.21.09-.35Z"
      fill="#000"
    />
    <path
      d="M60.12 57.02a.68.68 0 0 0-.59-.15c-.18.05-.22.2-.09.34.14.13.41.2.6.15.18-.06.22-.21.08-.34Z"
      fill="#2B3332"
    />
    <path
      d="M59.45 57.2c.13.14.4.2.59.16.19-.06.22-.21.08-.34"
      fill="#232B2A"
    />
    <path
      d="m60.43 56.36-.86-.21-.17.68v.02c-.02.06.01.12.08.2.14.13.41.2.6.15.1-.04.15-.07.17-.14l.18-.7Z"
      fill="#A4BCBB"
    />
    <path
      d="M59.42 56.9v.06l.06.09c.14.13.41.2.6.15.1-.03.15-.07.17-.14l.18-.7-.81-.2-.2.75Z"
      fill="#74918E"
    />
    <path
      d="M59.46 56.98v.04l.02.03c.14.13.41.2.6.15.1-.03.15-.07.17-.14l.18-.7-.76-.2-.21.82Z"
      fill="#526D6A"
    />
    <path
      d="M59.77 57.14v.05c.1.03.22.03.32 0 .1-.02.14-.06.16-.13l.18-.7-.43-.11-.23.89Z"
      fill="#3C5652"
    />
    <path
      d="M60.35 56.14a.68.68 0 0 0-.6-.15c-.2.04-.23.2-.09.34a.7.7 0 0 0 .52.17l.09-.01c.2-.06.23-.21.08-.35Z"
      fill="#BCCECC"
    />
    <path
      d="M59.66 56.33a.7.7 0 0 0 .52.17l.09-.01c.2-.06.23-.21.08-.35"
      fill="#A4BCBB"
    />
    <path
      d="M38.87 54.46s.35.36 1.03.91a16.6 16.6 0 0 0 7.79 3.42c.9.13 1.85.16 2.82.14a19.6 19.6 0 0 0 8.25-2.47c.42-.2.8-.45 1.18-.67.39-.22.77-.44 1.11-.68l1.03-.7c.33-.23.64-.46.93-.69.6-.43 1.13-.88 1.6-1.25.48-.37.88-.72 1.2-1.01l1.04-.9-.95 1c-.3.3-.67.69-1.12 1.1-.45.41-.95.9-1.53 1.35l-.92.76-1 .73c-.35.27-.72.5-1.1.75a23 23 0 0 1-3.82 1.98c-.93.37-1.89.7-2.88.92a15.9 15.9 0 0 1-5.93.2 14.96 14.96 0 0 1-7.8-3.88c-.62-.6-.93-1-.93-1Z"
      fill="#547277"
    />
    <path
      d="M49.6 28.56a.92.92 0 1 0 0-1.84.92.92 0 0 0 0 1.84Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M50.04 27.65a.43.43 0 1 1-.8-.33c.1-.22.4-.46.62-.37.22.09.27.48.18.7Z"
      fill="#FFA300"
    />
    <path
      d="M49.79 26.96c-.07-.03-.12-.02-.21.02a.75.75 0 0 0-.34.34.43.43 0 0 0 .46.6.43.43 0 0 0 .27-.25c.1-.23.04-.61-.18-.7Z"
      fill="#FFB600"
    />
    <path
      d="M49.58 26.98a.75.75 0 0 0-.34.34.43.43 0 0 0 .46.6"
      fill="#FFC200"
    />
    <path
      d="M50.08 27.35c0-.17-.08-.35-.22-.4-.14-.06-.31.02-.44.13 0 .04.02.08.05.12.1.14.33.23.5.2a.2.2 0 0 0 .11-.05Z"
      fill="#FFA300"
    />
    <path
      d="m50.06 27.18-.5-.2-.03.03v.01c0 .04 0 .08.04.13.07.1.24.16.36.15.06-.01.1-.04.11-.07v-.01l.02-.04Z"
      fill="#232B2A"
    />
    <path
      d="M49.57 27.15c.07.1.24.16.36.15.06-.01.1-.04.11-.07v-.01l.02-.04-.43-.18-.06.15Z"
      fill="#000"
    />
    <path
      d="M50.03 27.05a.43.43 0 0 0-.36-.15c-.12.02-.16.12-.09.21.08.1.24.16.37.15.12-.02.16-.11.08-.21Z"
      fill="#2D3534"
    />
    <path d="M50.03 27.05a.43.43 0 0 0-.36-.15l.36.15Z" fill="#C7D8D5" />
    <path
      d="M49.58 27.11c.08.1.24.16.37.15.12-.02.16-.11.08-.21"
      fill="#232B2A"
    />
    <path
      d="M50 27.05a.37.37 0 0 0-.31-.12c-.1.01-.14.1-.07.18.06.08.2.14.3.12.11-.01.15-.1.08-.18Z"
      fill="#90AFAD"
    />
    <path
      d="M49.98 27.06a.34.34 0 0 0-.29-.12c-.1.02-.13.1-.07.17.07.08.2.14.3.12.1-.01.13-.09.06-.17Z"
      fill="#7A9E9A"
    />
    <path
      d="M49.62 27.11c.07.08.2.14.3.12.1-.01.13-.09.06-.17"
      fill="#6A918B"
    />
    <path
      d="m50.05 27.13-.45-.18-.01.04c-.02.03 0 .08.02.12.07.08.21.14.32.12.05 0 .09-.03.1-.06l.02-.04Z"
      fill="#232B2A"
    />
    <path
      d="M49.61 27.1c.07.09.21.15.32.13.05 0 .09-.03.1-.06l.02-.04-.39-.15-.05.13Z"
      fill="#000"
    />
    <path
      d="M50.02 27.02a.36.36 0 0 0-.32-.13c-.1.01-.14.1-.07.18.06.09.2.15.31.13.1-.01.14-.1.08-.18Z"
      fill="#2D3534"
    />
    <path d="M50.02 27.02a.36.36 0 0 0-.32-.13l.32.13Z" fill="#414C4A" />
    <path
      d="M49.63 27.07c.06.09.2.15.31.13.1-.01.14-.1.08-.18"
      fill="#232B2A"
    />
    <path
      d="M49.99 27.02a.31.31 0 0 0-.27-.1c-.1 0-.12.08-.06.15.05.07.17.12.26.1.1 0 .13-.08.07-.15Z"
      fill="#000"
    />
    <path
      d="M49.98 27.03a.3.3 0 0 0-.26-.1c-.08 0-.1.07-.06.15.06.06.17.1.26.1.08-.02.1-.08.06-.15Z"
      fill="#2B3332"
    />
    <path
      d="M49.66 27.08c.06.06.17.1.26.1.08-.02.11-.08.06-.15"
      fill="#232B2A"
    />
    <path
      d="m50.15 26.76-.37-.15-.12.3c0 .03 0 .06.03.1a.3.3 0 0 0 .26.1c.04-.01.07-.03.08-.05l.12-.3Z"
      fill="#A4BCBB"
    />
    <path
      d="M49.67 26.94v.02c0 .01 0 .03.02.04a.3.3 0 0 0 .26.1c.04 0 .07-.02.08-.04l.12-.3-.35-.15-.13.33Z"
      fill="#74918E"
    />
    <path
      d="M49.68 26.97V27a.3.3 0 0 0 .27.1c.04 0 .07-.02.08-.04l.12-.3-.33-.14-.14.35Z"
      fill="#526D6A"
    />
    <path
      d="M49.81 27.06v.02c.04.03.1.03.14.03.04-.01.07-.03.08-.05l.12-.3-.18-.08-.16.38Z"
      fill="#3C5652"
    />
    <path
      d="M50.13 26.65a.3.3 0 0 0-.26-.1c-.09 0-.11.08-.06.15.05.06.14.1.22.1h.04c.09-.01.12-.08.06-.15Z"
      fill="#BCCECC"
    />
    <path
      d="M49.81 26.7c.05.06.14.1.22.1h.04c.09 0 .12-.08.06-.15"
      fill="#A4BCBB"
    />
    <path
      d="M52.2 28.59a.92.92 0 1 1-1.7-.69.92.92 0 0 1 1.7.69Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M51.78 28.25a.43.43 0 1 1-.8-.32c.09-.23.4-.47.62-.38.22.1.27.48.18.7Z"
      fill="#FFA300"
    />
    <path
      d="M51.52 27.57c-.07-.03-.11-.03-.2.01a.65.65 0 0 0-.34.35.43.43 0 0 0 .46.59.44.44 0 0 0 .27-.25c.09-.22.04-.61-.19-.7Z"
      fill="#FFB600"
    />
    <path
      d="M51.31 27.58c-.12.04-.28.22-.33.35a.43.43 0 0 0 .46.59"
      fill="#FFC200"
    />
    <path
      d="M51.82 27.96c-.01-.18-.08-.35-.22-.4-.14-.06-.31 0-.45.13 0 .03.02.08.06.12.1.13.32.22.49.2a.2.2 0 0 0 .12-.05Z"
      fill="#FFA300"
    />
    <path
      d="m51.8 27.78-.51-.2-.02.04v-.01.01c-.01.04 0 .09.03.13.08.1.24.17.37.15.06 0 .1-.03.11-.07l.02-.05Z"
      fill="#232B2A"
    />
    <path
      d="M51.3 27.76c.08.1.24.16.37.14.06 0 .1-.03.11-.07l.02-.05-.44-.18-.06.16Z"
      fill="#000"
    />
    <path
      d="M51.77 27.65a.46.46 0 0 0-.36-.15c-.13.02-.17.12-.1.21.09.1.25.17.37.15.13-.01.17-.11.09-.21Z"
      fill="#2D3534"
    />
    <path d="M51.77 27.65a.46.46 0 0 0-.37-.15l.37.15Z" fill="#C7D8D5" />
    <path
      d="M51.32 27.71c.08.1.24.17.36.15.13-.01.17-.11.09-.21"
      fill="#232B2A"
    />
    <path
      d="M51.74 27.65a.38.38 0 0 0-.31-.12c-.11.02-.14.1-.08.18.07.08.2.14.31.12.1-.01.14-.09.08-.18Z"
      fill="#90AFAD"
    />
    <path
      d="M51.72 27.67a.35.35 0 0 0-.29-.12c-.1.01-.13.09-.07.17.06.08.2.13.3.11.1-.01.12-.09.06-.16Z"
      fill="#7A9E9A"
    />
    <path d="M51.36 27.72c.06.08.2.13.3.11.1 0 .12-.09.06-.16" fill="#6A918B" />
    <path
      d="m51.78 27.73-.44-.18-.02.04c-.01.04 0 .08.03.12.07.09.2.14.32.12.05 0 .08-.02.1-.05v-.01l.01-.04Z"
      fill="#232B2A"
    />
    <path
      d="M51.35 27.7c.07.1.2.15.31.13.06 0 .1-.02.1-.05v-.01l.02-.04-.38-.15-.05.13Z"
      fill="#000"
    />
    <path
      d="M51.75 27.62a.37.37 0 0 0-.31-.13c-.1.02-.14.1-.08.19.07.08.21.14.32.12.1-.01.14-.1.07-.18Z"
      fill="#2D3534"
    />
    <path d="M51.75 27.62a.37.37 0 0 0-.31-.13l.31.13Z" fill="#414C4A" />
    <path
      d="M51.36 27.67c.07.09.21.15.32.13.1-.01.14-.1.07-.18"
      fill="#232B2A"
    />
    <path
      d="M51.72 27.62a.34.34 0 0 0-.26-.1c-.1 0-.13.08-.07.15a.3.3 0 0 0 .27.1c.1 0 .12-.07.06-.15Z"
      fill="#000"
    />
    <path
      d="M51.71 27.63a.3.3 0 0 0-.25-.1c-.09.01-.11.08-.06.15.05.06.17.11.25.1.09-.01.12-.08.06-.15Z"
      fill="#2B3332"
    />
    <path
      d="M51.4 27.68c.05.06.17.11.25.1.09-.01.12-.08.06-.15"
      fill="#232B2A"
    />
    <path
      d="m51.89 27.36-.37-.15-.12.3c0 .03 0 .06.02.1.06.07.18.11.26.1.05 0 .07-.02.09-.05l.12-.3Z"
      fill="#A4BCBB"
    />
    <path
      d="M51.4 27.54v.02l.02.05c.06.07.18.11.26.1.05 0 .07-.03.09-.05l.12-.3-.35-.14-.13.32Z"
      fill="#74918E"
    />
    <path
      d="M51.42 27.57v.04c.06.07.18.11.26.1.05 0 .07-.02.09-.05l.12-.3-.33-.13-.14.34Z"
      fill="#526D6A"
    />
    <path
      d="M51.55 27.67v.01h-.01c.05.03.1.04.14.03.05 0 .07-.02.09-.05l.12-.3-.19-.07-.15.38Z"
      fill="#3C5652"
    />
    <path
      d="M51.87 27.26a.31.31 0 0 0-.26-.11c-.1.01-.12.08-.06.15.04.06.14.1.22.11h.04c.09-.01.12-.08.06-.15Z"
      fill="#BCCECC"
    />
    <path
      d="M51.55 27.3c.04.06.14.1.22.11h.04c.09-.01.12-.08.06-.15"
      fill="#A4BCBB"
    />
    <path
      d="M54.35 28.52a.92.92 0 1 1-1.7-.69.92.92 0 0 1 1.7.7Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M53.94 28.19a.43.43 0 0 1-.57.23.43.43 0 0 1-.24-.56c.1-.22.4-.47.62-.37.22.09.28.47.19.7Z"
      fill="#FFA300"
    />
    <path
      d="M53.68 27.5c-.07-.03-.12-.02-.21.01a.77.77 0 0 0-.34.35.43.43 0 0 0 .46.6.42.42 0 0 0 .28-.26c.09-.22.03-.61-.19-.7Z"
      fill="#FFB600"
    />
    <path
      d="M53.47 27.51a.77.77 0 0 0-.34.35.43.43 0 0 0 .46.6"
      fill="#FFC200"
    />
    <path
      d="M53.97 27.89c0-.18-.08-.35-.22-.4-.14-.06-.3.01-.44.13 0 .04.02.08.05.12.1.13.33.22.5.2a.2.2 0 0 0 .11-.05Z"
      fill="#FFA300"
    />
    <path
      d="m53.96 27.71-.52-.2-.01.04c-.02.04 0 .09.03.14.08.1.24.16.36.14.06 0 .1-.03.12-.07l.02-.05Z"
      fill="#232B2A"
    />
    <path
      d="M53.46 27.69c.08.1.24.16.36.14.06 0 .1-.03.12-.07l.02-.04-.44-.18-.06.15Z"
      fill="#000"
    />
    <path
      d="M53.92 27.58a.42.42 0 0 0-.36-.14c-.12.01-.16.1-.08.2.07.1.23.17.36.16.12-.03.16-.12.08-.22Z"
      fill="#2D3534"
    />
    <path d="M53.92 27.58a.42.42 0 0 0-.36-.14l.36.14Z" fill="#C7D8D5" />
    <path
      d="M53.48 27.65c.07.1.24.16.36.14.12-.02.16-.1.08-.2"
      fill="#232B2A"
    />
    <path
      d="M53.9 27.59a.36.36 0 0 0-.32-.13c-.1.02-.14.1-.07.18.06.09.2.14.3.13.11-.02.15-.1.08-.18Z"
      fill="#90AFAD"
    />
    <path
      d="M53.88 27.6a.36.36 0 0 0-.3-.12c-.1.01-.12.09-.06.17.06.08.19.13.29.12.1-.02.13-.1.07-.17Z"
      fill="#7A9E9A"
    />
    <path
      d="M53.52 27.65c.06.08.19.13.29.12.1-.02.13-.1.07-.17"
      fill="#6A918B"
    />
    <path
      d="m53.94 27.67-.45-.19-.01.04c-.01.04 0 .08.03.12.06.09.2.14.31.13.05 0 .09-.03.1-.06v-.01l.02-.03Z"
      fill="#232B2A"
    />
    <path
      d="M53.5 27.64c.07.09.21.14.32.13.05 0 .09-.03.1-.06v-.01l.02-.04-.38-.15-.05.13Z"
      fill="#000"
    />
    <path
      d="M53.91 27.55a.38.38 0 0 0-.32-.13c-.1.02-.14.1-.07.19.07.08.2.14.32.13.1-.02.14-.1.07-.19Z"
      fill="#2D3534"
    />
    <path d="M53.91 27.55a.38.38 0 0 0-.32-.13l.32.13Z" fill="#414C4A" />
    <path d="M53.52 27.6c.07.1.2.15.32.14.1-.02.14-.1.07-.19" fill="#232B2A" />
    <path
      d="M53.88 27.56a.32.32 0 0 0-.27-.11c-.1.01-.12.08-.06.15.06.08.18.12.27.11.09-.01.12-.08.06-.15Z"
      fill="#000"
    />
    <path
      d="M53.87 27.56a.32.32 0 0 0-.25-.1c-.1.01-.12.08-.06.15a.3.3 0 0 0 .25.1c.09-.01.11-.08.06-.15Z"
      fill="#2B3332"
    />
    <path
      d="M53.56 27.6a.3.3 0 0 0 .25.1c.09 0 .11-.07.06-.14"
      fill="#232B2A"
    />
    <path
      d="m54.05 27.3-.37-.16-.12.3c-.01.03 0 .06.02.1a.3.3 0 0 0 .26.1c.04 0 .07-.02.08-.04l.13-.3Z"
      fill="#A4BCBB"
    />
    <path
      d="M53.56 27.47v.03l.02.04a.3.3 0 0 0 .26.1c.04 0 .07-.02.08-.05l.13-.3-.36-.14-.13.32Z"
      fill="#74918E"
    />
    <path
      d="M53.58 27.5v.01l-.01.01.01.02a.3.3 0 0 0 .26.1c.04 0 .07-.02.08-.05l.12-.3-.32-.13-.14.35Z"
      fill="#526D6A"
    />
    <path
      d="M53.7 27.6v.02c.04.02.1.03.14.02.04 0 .07-.02.08-.05l.12-.3-.18-.07-.16.38Z"
      fill="#3C5652"
    />
    <path
      d="M54.02 27.19a.31.31 0 0 0-.26-.1c-.09 0-.11.07-.06.14.05.06.14.1.22.11h.04c.1-.02.12-.08.06-.15Z"
      fill="#BCCECC"
    />
    <path
      d="M53.7 27.23c.05.06.14.1.22.11h.04c.1-.02.12-.08.06-.15"
      fill="#A4BCBB"
    />
    <path
      d="M56.35 27.92a.92.92 0 1 1-1.7-.7.92.92 0 0 1 1.7.7Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M55.94 27.58a.43.43 0 0 1-.57.24.43.43 0 0 1-.24-.57c.1-.22.4-.46.62-.37.23.1.28.48.19.7Z"
      fill="#FFA300"
    />
    <path
      d="M55.68 26.9c-.07-.03-.11-.03-.21.01a.72.72 0 0 0-.34.35c-.09.22.02.47.24.56.08.03.15.04.22.03a.43.43 0 0 0 .28-.25c.09-.22.03-.61-.19-.7Z"
      fill="#FFB600"
    />
    <path
      d="M55.47 26.91a.75.75 0 0 0-.34.34.44.44 0 0 0 .46.6"
      fill="#FFC200"
    />
    <path
      d="M55.98 27.28c-.02-.17-.09-.34-.23-.4s-.3.02-.44.13c0 .04.02.09.05.13.1.13.33.22.5.2a.2.2 0 0 0 .12-.06Z"
      fill="#FFA300"
    />
    <path
      d="m55.96 27.11-.52-.2-.01.04v-.01.01c-.02.04 0 .09.03.13.08.1.24.17.36.15.06 0 .1-.03.12-.07l.02-.05Z"
      fill="#232B2A"
    />
    <path
      d="M55.46 27.08c.08.1.24.17.36.15.06 0 .1-.04.12-.07l.02-.05-.44-.18-.06.15Z"
      fill="#000"
    />
    <path
      d="M55.93 26.98a.45.45 0 0 0-.37-.15c-.12.02-.16.11-.08.21.07.1.24.17.36.15.12-.02.16-.11.09-.21Z"
      fill="#2D3534"
    />
    <path d="M55.93 26.98a.45.45 0 0 0-.37-.15l.37.15Z" fill="#C7D8D5" />
    <path
      d="M55.48 27.04c.07.1.24.17.36.15.12-.02.16-.11.09-.21"
      fill="#232B2A"
    />
    <path
      d="M55.9 26.99a.36.36 0 0 0-.32-.13c-.1.01-.14.1-.07.18.07.08.2.14.31.12.1-.01.14-.1.07-.17Z"
      fill="#90AFAD"
    />
    <path
      d="M55.88 27a.35.35 0 0 0-.3-.12c-.1 0-.12.08-.06.16s.2.13.29.12c.1-.01.13-.09.07-.17Z"
      fill="#7A9E9A"
    />
    <path
      d="M55.52 27.04c.06.08.2.14.29.12.1-.01.13-.09.07-.17"
      fill="#6A918B"
    />
    <path
      d="m55.94 27.06-.45-.18-.01.04c-.01.04 0 .08.03.12.06.08.2.14.31.13.05-.01.09-.03.1-.07l.02-.04Z"
      fill="#232B2A"
    />
    <path
      d="M55.5 27.04c.07.08.21.14.32.13.05-.01.09-.04.1-.07l.02-.04-.38-.15-.06.13Z"
      fill="#000"
    />
    <path
      d="M55.9 26.95a.35.35 0 0 0-.3-.13c-.11.02-.15.1-.08.18.07.09.2.15.32.13.1-.02.14-.1.07-.18Z"
      fill="#2D3534"
    />
    <path d="M55.9 26.95a.35.35 0 0 0-.3-.13l.3.13Z" fill="#414C4A" />
    <path d="M55.52 27c.07.09.2.15.32.13.1-.01.14-.1.07-.18" fill="#232B2A" />
    <path
      d="M55.88 26.95a.32.32 0 0 0-.27-.1c-.1 0-.12.08-.06.15a.3.3 0 0 0 .27.1c.09 0 .12-.07.06-.15Z"
      fill="#000"
    />
    <path
      d="M55.87 26.96a.31.31 0 0 0-.26-.1c-.08.01-.1.07-.05.14a.3.3 0 0 0 .25.1c.09 0 .11-.07.06-.14Z"
      fill="#2B3332"
    />
    <path d="M55.56 27a.3.3 0 0 0 .25.1c.09 0 .11-.07.06-.14" fill="#232B2A" />
    <path
      d="m56.05 26.69-.37-.15-.12.3c-.01.03 0 .06.02.1a.3.3 0 0 0 .26.1c.04 0 .07-.02.08-.05l.13-.3Z"
      fill="#A4BCBB"
    />
    <path
      d="M55.56 26.87v.02c0 .02 0 .03.02.04a.3.3 0 0 0 .26.1c.04 0 .07-.01.08-.04l.13-.3-.36-.14-.13.32Z"
      fill="#74918E"
    />
    <path
      d="M55.58 26.9v.03a.3.3 0 0 0 .26.1c.04 0 .07-.01.08-.04l.13-.3-.33-.14-.14.35Z"
      fill="#526D6A"
    />
    <path
      d="M55.7 27v.02c.05.02.1.03.14.02.04 0 .07-.02.08-.05l.13-.3-.2-.08-.15.38Z"
      fill="#3C5652"
    />
    <path
      d="M56.02 26.59a.3.3 0 0 0-.26-.11c-.08 0-.11.08-.06.15.05.06.14.1.23.1h.04c.08 0 .11-.08.05-.14Z"
      fill="#BCCECC"
    />
    <path
      d="M55.7 26.63c.05.06.14.1.23.1h.04c.08 0 .11-.08.05-.14"
      fill="#A4BCBB"
    />
    <path
      d="M57.06 27.83a.92.92 0 1 0 0-1.83.92.92 0 0 0 0 1.83Z"
      fill="#FFC200"
      opacity=".4"
    />
    <path
      d="M57.5 26.87a.43.43 0 0 1-.53.31.44.44 0 0 1-.31-.53c.06-.23.33-.51.56-.45.23.06.34.43.28.67Z"
      fill="#FFA300"
    />
    <path
      d="M57.15 26.22c-.07-.02-.12 0-.2.05-.12.05-.26.26-.3.38a.44.44 0 0 0 .55.53c.11-.06.2-.16.23-.29.06-.23-.04-.6-.28-.67Z"
      fill="#FFB600"
    />
    <path
      d="M56.94 26.27a.78.78 0 0 0-.28.38.44.44 0 0 0 .54.53"
      fill="#FFC200"
    />
    <path
      d="M57.5 26.57c-.04-.18-.13-.34-.28-.37-.14-.04-.3.06-.42.2l.07.1c.12.12.35.18.52.13a.22.22 0 0 0 .1-.06Z"
      fill="#FFA300"
    />
    <path
      d="m57.46 26.4-.54-.14-.01.05v-.01c0 .05 0 .1.05.14.09.08.26.13.38.1.06-.02.1-.06.1-.1l.02-.05Z"
      fill="#232B2A"
    />
    <path
      d="M56.96 26.44c.09.08.26.13.38.1.06-.02.1-.06.1-.1l.02-.05-.46-.11-.04.16Z"
      fill="#000"
    />
    <path
      d="M57.4 26.27a.43.43 0 0 0-.37-.1c-.13.04-.15.14-.06.23.09.08.26.12.38.1.12-.04.15-.14.05-.23Z"
      fill="#2D3534"
    />
    <path d="M57.4 26.27a.43.43 0 0 0-.37-.1l.37.1Z" fill="#C7D8D5" />
    <path
      d="M56.97 26.4c.1.08.26.12.38.1.12-.04.15-.14.05-.23"
      fill="#232B2A"
    />
    <path
      d="M57.38 26.28a.4.4 0 0 0-.33-.08c-.1.03-.12.11-.05.19.08.07.23.1.33.08.1-.03.12-.12.05-.19Z"
      fill="#90AFAD"
    />
    <path
      d="M57.36 26.3a.35.35 0 0 0-.3-.08c-.1.02-.12.1-.05.17.07.07.21.1.3.08.1-.03.12-.1.05-.18Z"
      fill="#7A9E9A"
    />
    <path d="M57.01 26.4c.07.06.21.1.3.07.1-.03.12-.11.05-.18" fill="#6A918B" />
    <path
      d="m57.43 26.35-.47-.12v.04c-.01.04 0 .08.04.12.08.07.22.1.33.08.05-.01.08-.04.09-.07v-.01l.01-.04Z"
      fill="#232B2A"
    />
    <path
      d="M57 26.39c.08.07.23.1.33.08.05-.01.08-.04.09-.07v-.01l.01-.04-.4-.1-.03.14Z"
      fill="#000"
    />
    <path
      d="M57.39 26.24a.37.37 0 0 0-.33-.08c-.1.03-.13.12-.05.19s.22.11.33.08c.1-.03.13-.11.05-.19Z"
      fill="#2D3534"
    />
    <path d="M57.39 26.24a.37.37 0 0 0-.33-.08l.33.08Z" fill="#414C4A" />
    <path d="M57 26.35c.09.07.23.11.34.08.1-.03.12-.11.05-.19" fill="#232B2A" />
    <path
      d="M57.36 26.25a.31.31 0 0 0-.29-.07c-.08.02-.1.1-.03.16.06.07.19.1.28.07.09-.02.1-.1.04-.16Z"
      fill="#000"
    />
    <path
      d="M57.35 26.26a.3.3 0 0 0-.27-.07c-.08.02-.1.1-.04.15a.3.3 0 0 0 .27.07c.08-.02.1-.09.04-.15Z"
      fill="#2B3332"
    />
    <path
      d="M57.04 26.34a.3.3 0 0 0 .27.07c.08-.02.1-.1.04-.15"
      fill="#232B2A"
    />
    <path
      d="m57.49 25.96-.39-.1-.08.32c0 .03.01.06.04.1.06.05.18.09.27.06.04-.01.07-.03.08-.06l.08-.32Z"
      fill="#A4BCBB"
    />
    <path
      d="M57.03 26.21v.02l.03.04c.06.06.18.1.27.07.04-.01.07-.03.08-.06l.08-.32-.37-.09-.09.34Z"
      fill="#74918E"
    />
    <path
      d="M57.05 26.24v.03c.07.06.2.1.28.07.04-.01.07-.03.08-.06l.08-.31-.35-.1-.09.37Z"
      fill="#526D6A"
    />
    <path
      d="M57.19 26.31v.03c.05.01.1.01.14 0 .04-.01.07-.03.08-.06l.08-.31-.2-.05-.1.4Z"
      fill="#3C5652"
    />
    <path
      d="M57.45 25.87a.3.3 0 0 0-.27-.07c-.09.02-.1.1-.04.15.05.06.15.09.23.08h.04c.09-.03.1-.1.04-.16Z"
      fill="#BCCECC"
    />
    <path
      d="M57.14 25.95c.05.06.15.09.23.08h.04c.09-.03.1-.1.04-.16"
      fill="#A4BCBB"
    />
    <path
      d="M47.8 25.11s.16.17.47.41a7.42 7.42 0 0 0 3.5 1.54 6.5 6.5 0 0 0 2.56-.14 8.08 8.08 0 0 0 2.4-.91c.2-.09.36-.2.54-.3l.5-.3.46-.32.42-.3c.27-.2.5-.4.71-.57.22-.17.4-.33.54-.45l.47-.41-.43.45-.5.5c-.2.18-.42.4-.69.6l-.4.34c-.16.1-.3.22-.46.33l-.5.34a10.35 10.35 0 0 1-3 1.3 7.08 7.08 0 0 1-3.85-.22 6.56 6.56 0 0 1-2.31-1.43 3.91 3.91 0 0 1-.42-.46Z"
      fill="#547277"
    />
    <path
      d="M59.68 65.5c0 .56-.6 2-1.34 2-.74 0-1.34-1.44-1.34-2 0-.55.6-1 1.34-1 .74 0 1.34.45 1.34 1Z"
      fill="#079142"
    />
    <path
      d="M58.14 64.66c-.34 0-.64.1-.88.25a.85.85 0 0 0-.26.6c0 .56.6 1.98 1.34 1.98a.7.7 0 0 0 .37-.12c.46-.44.77-1.3.77-1.7 0-.55-.6-1-1.34-1Z"
      fill="#14C45F"
    />
    <path
      d="M59.2 65.05a1.7 1.7 0 0 0-1.54.12.85.85 0 0 0-.26.6c0 .4.31 1.25.76 1.7l.18.02a.7.7 0 0 0 .37-.12c.46-.44.77-1.3.77-1.7 0-.24-.1-.45-.29-.62Z"
      fill="#0BA852"
    />
    <path
      d="M58.34 66.13a.46.46 0 1 0 0-.91.46.46 0 0 0 0 .91Z"
      fill="#14C45F"
    />
    <path
      d="M58.28 65.22a.46.46 0 0 0 0 .9.46.46 0 0 0 0-.9Zm.32-.7a1.75 1.75 0 0 0-.26-.02c-.74 0-1.34.45-1.34 1"
      fill="#27E071"
    />
    <path
      d="M58.92 64.57a1.29 1.29 0 0 0-1.16 0c-.32.18-.32.49 0 .67.32.19.84.19 1.16 0 .32-.18.32-.49 0-.67Z"
      fill="#079142"
    />
    <path
      d="M58.92 64.48a1.3 1.3 0 0 0-1.16 0c-.32.19-.32.49 0 .67.32.19.84.19 1.16 0 .32-.18.32-.48 0-.67Z"
      fill="#DB8C19"
    />
    <path
      d="M58.88 64.47a1.2 1.2 0 0 0-1.08 0c-.3.18-.3.46 0 .63.3.17.78.17 1.08 0 .3-.17.3-.46 0-.63Z"
      fill="#D8741A"
    />
    <path d="M57.8 65.1c.3.17.78.17 1.08 0 .3-.17.3-.45 0-.63" fill="#C96717" />
    <path
      d="M58.09 65.2c.16.04.34.03.5 0v-.51l-.5.11v.4Z"
      fill="#C96717"
      opacity=".3"
    />
    <path
      d="M58.15 64.9c-.17 0-.35-.12-.35-.4 0-.31.21-.67.48-.83.2-.1.39-.09.5.05.06.08.1.18.1.3 0 .3-.22.66-.48.82a.49.49 0 0 1-.25.07Zm.37-1.06a.26.26 0 0 0-.12.04.8.8 0 0 0-.36.61c0 .06.01.18.11.18.04 0 .08-.02.13-.04a.8.8 0 0 0 .35-.62.23.23 0 0 0-.04-.14c-.01-.02-.04-.03-.07-.03Z"
      fill="#F7A23C"
    />
    <path
      d="M58.87 64.01a.46.46 0 0 0-.09-.29.31.31 0 0 0-.14-.1.55.55 0 0 0-.12.05c-.23.13-.4.41-.46.68a.8.8 0 0 1 .34-.47.26.26 0 0 1 .12-.04c.03 0 .06.01.07.03.03.03.04.08.04.14a.8.8 0 0 1-.35.62.25.25 0 0 1-.13.04c-.05 0-.08-.04-.1-.09.03.17.12.27.23.3a.63.63 0 0 0 .12-.04c.26-.16.47-.52.47-.83Z"
      fill="#E59120"
    />
    <path
      d="M45.37 63.96c0 .56-.6 1.98-1.34 1.98-.74 0-1.34-1.42-1.34-1.98s.6-1 1.34-1c.74 0 1.34.44 1.34 1Z"
      fill="#079142"
    />
    <path
      d="M43.83 63.12c-.34 0-.64.09-.88.24a.85.85 0 0 0-.26.6c0 .56.6 1.98 1.34 1.98a.7.7 0 0 0 .37-.11c.46-.45.77-1.3.77-1.7 0-.56-.6-1.01-1.34-1.01Z"
      fill="#14C45F"
    />
    <path
      d="M44.88 63.5a1.7 1.7 0 0 0-1.53.12.85.85 0 0 0-.26.6c0 .4.31 1.25.77 1.7l.17.02a.7.7 0 0 0 .37-.12 3 3 0 0 0 .77-1.7c0-.23-.1-.45-.29-.62Z"
      fill="#0BA852"
    />
    <path
      d="M44.03 64.58a.46.46 0 1 0 0-.91.46.46 0 0 0 0 .91Z"
      fill="#14C45F"
    />
    <path
      d="M43.97 63.67a.46.46 0 0 0 0 .9.46.46 0 0 0 0-.9Zm.31-.7a1.74 1.74 0 0 0-.25-.02c-.74 0-1.34.45-1.34 1.01"
      fill="#27E071"
    />
    <path
      d="M44.6 63.02a1.3 1.3 0 0 0-1.15 0c-.32.18-.32.49 0 .67.32.19.84.19 1.16 0 .32-.18.32-.49 0-.67Z"
      fill="#079142"
    />
    <path
      d="M44.6 62.93a1.29 1.29 0 0 0-1.15 0c-.32.19-.32.49 0 .67.32.19.84.19 1.16 0 .32-.18.32-.48 0-.67Z"
      fill="#DB8C19"
    />
    <path
      d="M44.57 62.92a1.2 1.2 0 0 0-1.08 0c-.3.18-.3.46 0 .63.3.17.78.17 1.08 0 .3-.17.3-.45 0-.63Z"
      fill="#D8741A"
    />
    <path
      d="M43.49 63.55c.3.17.78.17 1.08 0 .3-.17.3-.45 0-.63"
      fill="#C96717"
    />
    <path
      d="M43.78 63.65c.16.04.34.04.5 0v-.51l-.5.12v.4Z"
      fill="#C96717"
      opacity=".3"
    />
    <path
      d="M43.85 63.36c-.18 0-.35-.13-.35-.42 0-.3.2-.66.47-.82.2-.1.4-.09.5.05.06.08.1.18.1.3 0 .3-.21.66-.48.82a.49.49 0 0 1-.24.07Zm.36-1.07a.26.26 0 0 0-.12.04.8.8 0 0 0-.36.61c0 .05.02.18.12.18l.12-.04a.8.8 0 0 0 .35-.62.23.23 0 0 0-.03-.14.09.09 0 0 0-.08-.03Z"
      fill="#F7A23C"
    />
    <path
      d="M44.56 62.46a.46.46 0 0 0-.09-.29.32.32 0 0 0-.14-.1.61.61 0 0 0-.12.05c-.22.13-.4.41-.46.68a.8.8 0 0 1 .34-.47.27.27 0 0 1 .12-.04c.03 0 .06.01.07.03.03.03.04.08.04.15a.8.8 0 0 1-.35.6.27.27 0 0 1-.13.05c-.05 0-.08-.04-.1-.09.03.17.12.27.23.3a.59.59 0 0 0 .12-.04c.26-.16.47-.52.47-.83Z"
      fill="#E59120"
    />
    <defs>
      <linearGradient
        id="a"
        gradientUnits="userSpaceOnUse"
        x1="214"
        x2="214"
        y1="10.34"
        y2="104.34"
      >
        <stop stop-color="#CDEFFF" />
        <stop offset=".38" stop-color="#fff" />
      </linearGradient>
      <linearGradient
        id="b"
        gradientUnits="userSpaceOnUse"
        x1="214"
        x2="214"
        y1="40.42"
        y2="99.18"
      >
        <stop stop-color="#D8F3FF" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
      <linearGradient
        id="c"
        gradientUnits="userSpaceOnUse"
        x1="214"
        x2="214"
        y1="40.42"
        y2="99.18"
      >
        <stop stop-color="#D8F3FF" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
    </defs>
  </svg>
</template>
